var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlog4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer_1",
    "data-name": "layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 900 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_6);}.cls-4,.cls-50{fill:#02247d;}.cls-46,.cls-48,.cls-5,.cls-50,.cls-52,.cls-54{fill-rule:evenodd;}.cls-5{opacity:0.5;fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_142);}.cls-6{fill:url(#linear-gradient);}.cls-7{fill:url(#linear-gradient-2);}.cls-8{fill:url(#linear-gradient-3);}.cls-9{fill:url(#linear-gradient-4);}.cls-10{fill:url(#linear-gradient-5);}.cls-11{fill:url(#linear-gradient-6);}.cls-12{fill:url(#linear-gradient-7);}.cls-13{fill:url(#linear-gradient-8);}.cls-14{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_144);}.cls-15{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_144-2);}.cls-16{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_144-3);}.cls-17{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_144-4);}.cls-18{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_144-5);}.cls-19{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_2);}.cls-20{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15);}.cls-21{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15-2);}.cls-22{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15-3);}.cls-23{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15-4);}.cls-24{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15-5);}.cls-25{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15-6);}.cls-26{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15-7);}.cls-27{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15-8);}.cls-28{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15-9);}.cls-29{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15-10);}.cls-30{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15-11);}.cls-31{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15-12);}.cls-32{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15-13);}.cls-33{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15-14);}.cls-34{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15-15);}.cls-35{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15-16);}.cls-36{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_144-6);}.cls-37{fill:url(#linear-gradient-9);}.cls-38{fill:url(#linear-gradient-10);}.cls-39{fill:url(#linear-gradient-11);}.cls-40{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_112);}.cls-41{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_112-2);}.cls-42{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_112-3);}.cls-43{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_112-4);}.cls-44{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_112-5);}.cls-45{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_112-6);}.cls-46{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_40);}.cls-47{fill:url(#linear-gradient-12);}.cls-48,.cls-88{fill:#fffeff;}.cls-49{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15-17);}.cls-51{fill:url(#linear-gradient-13);}.cls-52{fill:url(#linear-gradient-14);}.cls-53{fill:url(#linear-gradient-15);}.cls-54{fill:url(#linear-gradient-16);}.cls-55{fill:url(#linear-gradient-17);}.cls-56{fill:url(#linear-gradient-18);}.cls-57{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_112-7);}.cls-58{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_112-8);}.cls-59{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_112-9);}.cls-60{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_112-10);}.cls-61{fill:url(#linear-gradient-19);}.cls-62{fill:url(#linear-gradient-20);}.cls-63{fill:url(#linear-gradient-21);}.cls-64{fill:url(#linear-gradient-22);}.cls-65{fill:url(#linear-gradient-23);}.cls-66{fill:url(#linear-gradient-24);}.cls-67{fill:url(#linear-gradient-25);}.cls-68{fill:url(#linear-gradient-26);}.cls-69{fill:url(#linear-gradient-27);}.cls-70{fill:url(#linear-gradient-28);}.cls-71{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_6-2);}.cls-72{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_6-3);}.cls-73{fill:url(#linear-gradient-29);}.cls-74{fill:url(#linear-gradient-30);}.cls-75{fill:url(#linear-gradient-31);}.cls-76{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_144-7);}.cls-77{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_12);}.cls-78{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_12-2);}.cls-79{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_12-3);}.cls-80{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_12-4);}.cls-81{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_12-5);}.cls-82{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_12-6);}.cls-83{fill:url(#linear-gradient-32);}.cls-84{fill:url(#linear-gradient-33);}.cls-85{fill:url(#linear-gradient-34);}.cls-86{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_12-7);}.cls-87{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_144-8);}.cls-89{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_144-9);}.cls-90{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15-18);}.cls-91{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15-19);}.cls-92{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15-20);}.cls-93{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15-21);}.cls-94{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_144-10);}.cls-95{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_12-8);}.cls-96{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_112-11);}.cls-97{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_144-11);}.cls-98{fill:#fff;}.cls-99{fill:url(#linear-gradient-35);}.cls-100{fill:url(#linear-gradient-36);}.cls-101{fill:url(#linear-gradient-37);}.cls-102{fill:url(#linear-gradient-38);}.cls-103{fill:url(#linear-gradient-39);}.cls-104{fill:url(#linear-gradient-40);}.cls-105{fill:url(#linear-gradient-41);}.cls-106{fill:url(#linear-gradient-42);}.cls-107{fill:url(#linear-gradient-43);}.cls-108{fill:url(#linear-gradient-44);}.cls-109{fill:url(#linear-gradient-45);}.cls-110{fill:url(#linear-gradient-46);}.cls-111{fill:url(#linear-gradient-47);}.cls-112{fill:url(#linear-gradient-48);}.cls-113{fill:url(#linear-gradient-49);}.cls-114{fill:url(#linear-gradient-50);}.cls-115{fill:url(#linear-gradient-51);}.cls-116{fill:url(#linear-gradient-52);}.cls-117{fill:url(#linear-gradient-53);}.cls-118{fill:url(#linear-gradient-54);}.cls-119{fill:url(#linear-gradient-55);}.cls-120{fill:url(#linear-gradient-56);}.cls-121{fill:url(#linear-gradient-57);}.cls-122{fill:url(#linear-gradient-58);}.cls-123{fill:url(#linear-gradient-59);}.cls-124{fill:url(#linear-gradient-60);}.cls-125{fill:url(#linear-gradient-61);}.cls-126{fill:url(#linear-gradient-62);}.cls-127{fill:url(#linear-gradient-63);}.cls-128{fill:url(#linear-gradient-64);}.cls-129{fill:url(#linear-gradient-65);}.cls-130{fill:url(#linear-gradient-66);}.cls-131{fill:url(#linear-gradient-67);}.cls-132{fill:url(#linear-gradient-68);}.cls-133{fill:url(#linear-gradient-69);}.cls-134{fill:url(#linear-gradient-70);}.cls-135{fill:url(#linear-gradient-71);}.cls-136{fill:url(#linear-gradient-72);}.cls-137{fill:url(#linear-gradient-73);}.cls-138{fill:url(#linear-gradient-74);}.cls-139{fill:url(#linear-gradient-75);}.cls-140{fill:url(#linear-gradient-76);}.cls-141{fill:url(#linear-gradient-77);}.cls-142{fill:url(#linear-gradient-78);}.cls-143{fill:url(#linear-gradient-79);}.cls-144{fill:url(#linear-gradient-80);}.cls-145{fill:url(#linear-gradient-81);}.cls-146{fill:url(#linear-gradient-82);}.cls-147{fill:url(#linear-gradient-83);}.cls-148{fill:url(#linear-gradient-84);}.cls-149{fill:url(#linear-gradient-85);}.cls-150{fill:url(#linear-gradient-86);}.cls-151{fill:url(#linear-gradient-87);}.cls-152{fill:url(#linear-gradient-88);}.cls-153{fill:url(#linear-gradient-89);}.cls-154{fill:url(#linear-gradient-90);}.cls-155{fill:url(#linear-gradient-91);}.cls-156{fill:url(#linear-gradient-92);}.cls-157{fill:url(#linear-gradient-93);}.cls-158{fill:url(#linear-gradient-94);}.cls-159{fill:url(#linear-gradient-95);}.cls-160{fill:url(#linear-gradient-96);}.cls-161{fill:url(#linear-gradient-97);}.cls-162{fill:url(#linear-gradient-98);}.cls-163{fill:url(#linear-gradient-99);}.cls-164{fill:url(#linear-gradient-100);}.cls-165{fill:url(#linear-gradient-101);}.cls-166{fill:url(#linear-gradient-102);}.cls-167{fill:url(#linear-gradient-103);}.cls-168{fill:url(#linear-gradient-104);}.cls-169{fill:url(#linear-gradient-105);}.cls-170{fill:url(#linear-gradient-106);}.cls-171{fill:url(#linear-gradient-107);}.cls-172{fill:url(#linear-gradient-108);}.cls-173{fill:#c2e3f0;}.cls-174{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15-22);}.cls-175{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15-23);}.cls-176{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15-24);}.cls-177{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104);}.cls-178{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-2);}.cls-179{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-3);}.cls-180{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-4);}.cls-181{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-5);}.cls-182{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-6);}.cls-183{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-7);}.cls-184{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-8);}.cls-185{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-9);}.cls-186{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-10);}.cls-187{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-11);}.cls-188{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-12);}.cls-189{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-13);}.cls-190{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-14);}.cls-191{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-15);}.cls-192{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-16);}.cls-193{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-17);}.cls-194{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-18);}.cls-195{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-19);}.cls-196{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-20);}.cls-197{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-21);}.cls-198{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-22);}.cls-199{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-24);}.cls-200{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-25);}.cls-201{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-27);}.cls-202{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-28);}.cls-203{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-29);}.cls-204{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-30);}.cls-205{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-31);}.cls-206{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-32);}.cls-207{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-33);}.cls-208{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-34);}.cls-209{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-35);}.cls-210{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-37);}.cls-211{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-38);}.cls-212{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-40);}.cls-213{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-41);}.cls-214{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-42);}.cls-215{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-43);}.cls-216{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-45);}.cls-217{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-46);}.cls-218{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_104-47);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 900,
    height: 600
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_6",
    y1: 300,
    x2: 900,
    y2: 300,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f41db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022894"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_142",
    x1: 5416.97,
    y1: 1956.72,
    x2: 5519.03,
    y2: 1956.72,
    gradientTransform: "translate(-1423.39 5849.97) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#03fbfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#29fcfc",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#83fdfe",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#c6fefe",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#efffff",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 240.8,
    y1: 287.1,
    x2: 251.81,
    y2: 287.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f41db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03f3f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 175.72,
    y1: 293.86,
    x2: 235.94,
    y2: 293.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 256.67,
    y1: 293.86,
    x2: 316.89,
    y2: 293.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 210.34,
    y1: 194.63,
    x2: 282.27,
    y2: 194.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 210.34,
    y1: 361.26,
    x2: 282.27,
    y2: 361.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 159.45,
    y1: 352.25,
    x2: 333.16,
    y2: 352.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 127.97,
    y1: 273.44,
    x2: 364.64,
    y2: 273.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#964ae2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03ffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 126.97,
    y1: 273.44,
    x2: 365.64,
    y2: 273.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#03f3f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f41db"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_144",
    x1: 224,
    y1: 234.03,
    x2: 234.29,
    y2: 234.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffca02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fa9a35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#f67160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#f35480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#f14193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f03b9a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_144-2",
    x1: 163.63,
    y1: 244.32,
    x2: 224,
    y2: 244.32,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_144-3",
    x1: 239.69,
    y1: 316.56,
    x2: 249.98,
    y2: 316.56,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_144-4",
    x1: 172.7,
    y1: 316.56,
    x2: 229.4,
    y2: 316.56,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_144-5",
    x1: 236.92,
    y1: 273.44,
    x2: 336.63,
    y2: 273.44,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_2",
    x1: 52.01,
    y1: 480.81,
    x2: 700.95,
    y2: 480.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#022894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f41db"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15",
    x1: 478.18,
    y1: 461.68,
    x2: 566.38,
    y2: 461.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#03bef2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#964ae2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15-2",
    x1: 204.24,
    y1: 442.77,
    x2: 399.59,
    y2: 442.77,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15-3",
    x1: 444.45,
    y1: 461.68,
    x2: 462.18,
    y2: 461.68,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15-4",
    x1: 579.38,
    y1: 480.2,
    x2: 631.15,
    y2: 480.2,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15-5",
    x1: 559.59,
    y1: 480.2,
    x2: 570,
    y2: 480.2,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15-6",
    x1: 575.45,
    y1: 443.95,
    x2: 605.6,
    y2: 443.95,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15-7",
    x1: 616.79,
    y1: 443.95,
    x2: 627.02,
    y2: 443.95,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15-8",
    x1: 563.91,
    y1: 443.95,
    x2: 569.98,
    y2: 443.95,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15-9",
    x1: 404.01,
    y1: 470.66,
    x2: 434.16,
    y2: 470.66,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15-10",
    x1: 445.35,
    y1: 470.66,
    x2: 455.58,
    y2: 470.66,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15-11",
    x1: 392.48,
    y1: 470.66,
    x2: 398.54,
    y2: 470.66,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15-12",
    x1: 262.02,
    y1: 460.68,
    x2: 320.42,
    y2: 460.68,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15-13",
    x1: 342.09,
    y1: 460.68,
    x2: 361.91,
    y2: 460.68,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15-14",
    x1: 239.69,
    y1: 460.68,
    x2: 251.43,
    y2: 460.68,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15-15",
    x1: 108.11,
    y1: 454.01,
    x2: 133.29,
    y2: 454.01,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15-16",
    x1: 145.21,
    y1: 454.01,
    x2: 156.11,
    y2: 454.01,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_144-6",
    x1: 314.74,
    y1: 286.77,
    x2: 533.32,
    y2: 286.77,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 313.1,
    y1: 286.77,
    x2: 534.34,
    y2: 286.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 348.87,
    y1: 192.58,
    x2: 518.44,
    y2: 192.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04feff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#3bbaf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#6b7fea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#895ae4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#944ce2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 347.24,
    y1: 192.55,
    x2: 520.65,
    y2: 192.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_112",
    x1: 3125.03,
    y1: -1060.23,
    x2: 3144.02,
    y2: -1060.23,
    gradientTransform: "translate(1470.16 3246.8) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffca02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f03b9a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_112-2",
    x1: 3125.03,
    y1: -1049.43,
    x2: 3144.02,
    y2: -1049.43,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_112"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_112-3",
    x1: 3125.49,
    y1: -1038.64,
    x2: 3144.48,
    y2: -1038.64,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_112"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_112-4",
    x1: 3125.49,
    y1: -1027.84,
    x2: 3144.48,
    y2: -1027.84,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_112"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_112-5",
    x1: 218.89,
    y1: 109.41,
    x2: 315.89,
    y2: 109.41,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_112"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_112-6",
    x1: 557.28,
    y1: 268.51,
    x2: 654.28,
    y2: 268.51,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_112"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_40",
    x1: 88.61,
    y1: 311.42,
    x2: 110.52,
    y2: 311.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f41db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02247d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 87.61,
    y1: 311.63,
    x2: 111.52,
    y2: 311.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02247d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#024792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#039ec6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03f3f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15-17",
    x1: 4459.9,
    y1: -326.51,
    x2: 4481.26,
    y2: -326.51,
    gradientTransform: "translate(541.14 4893.03) rotate(-90)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 4464.98,
    y1: -330.55,
    x2: 4476.26,
    y2: -330.55,
    gradientTransform: "translate(541.14 4893.03) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#964ae2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#944de2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8c57e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7e67e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#6b7eea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#539cef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#35c1f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#13ecfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03ffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 4461.11,
    y1: -244,
    x2: 4480.32,
    y2: -244,
    gradientTransform: "translate(541.14 4893.03) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#03ffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#35c2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5f8eed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#7d69e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#8f52e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#964ae2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 4460.11,
    y1: -244,
    x2: 4481.32,
    y2: -244,
    gradientTransform: "translate(541.14 4893.03) rotate(-90)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 4467.42,
    y1: -244,
    x2: 4474.01,
    y2: -244,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 4466.42,
    y1: -244,
    x2: 4475.01,
    y2: -244,
    gradientTransform: "translate(541.14 4893.03) rotate(-90)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 3728.37,
    y1: 5741.5,
    x2: 3746.34,
    y2: 5741.5,
    gradientTransform: "translate(4116.65 6163.85) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_112-7",
    x1: 4645.92,
    y1: 1005.46,
    x2: 4664.91,
    y2: 1005.46,
    gradientTransform: "translate(-678.66 4810.23) rotate(-90)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_112"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_112-8",
    x1: 4645.92,
    y1: 994.67,
    x2: 4664.91,
    y2: 994.67,
    gradientTransform: "translate(-678.66 4810.23) rotate(-90)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_112"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_112-9",
    x1: 4645.46,
    y1: 983.87,
    x2: 4664.45,
    y2: 983.87,
    gradientTransform: "translate(-678.66 4810.23) rotate(-90)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_112"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_112-10",
    x1: 4645.46,
    y1: 973.07,
    x2: 4664.45,
    y2: 973.07,
    gradientTransform: "translate(-678.66 4810.23) rotate(-90)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_112"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 601.2,
    y1: 203.92,
    x2: 542.21,
    y2: 192.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffca02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fa9a35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#f67160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#f35480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#f14193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f03b9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#623bca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 602.99,
    y1: 173.94,
    x2: 583.26,
    y2: 170.01,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 592.02,
    y1: 176.44,
    x2: 564.67,
    y2: 171.01,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 3998.79,
    y1: 531.59,
    x2: 4024.7,
    y2: 531.59,
    gradientTransform: "matrix(-0.98, -0.2, -0.2, 0.98, 4587.5, 402.45)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 4024.72,
    y1: 502.81,
    x2: 4050.51,
    y2: 502.81,
    gradientTransform: "matrix(-0.98, -0.2, -0.2, 0.98, 4587.5, 402.45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 4042.26,
    y1: 536.23,
    x2: 4062.16,
    y2: 536.23,
    gradientTransform: "matrix(-0.98, -0.2, -0.2, 0.98, 4587.5, 402.45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 4056.49,
    y1: 510.03,
    x2: 4072.36,
    y2: 510.03,
    gradientTransform: "matrix(-0.98, -0.2, -0.2, 0.98, 4587.5, 402.45)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 4050.75,
    y1: 511.13,
    x2: 4069.28,
    y2: 511.13,
    gradientTransform: "matrix(-0.98, -0.2, -0.2, 0.98, 4587.5, 402.45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 4020.05,
    y1: 519,
    x2: 4063.4,
    y2: 519,
    gradientTransform: "matrix(-0.98, -0.2, -0.2, 0.98, 4587.5, 402.45)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 4019.04,
    y1: 518.84,
    x2: 4064.72,
    y2: 518.84,
    gradientTransform: "matrix(-0.98, -0.2, -0.2, 0.98, 4587.5, 402.45)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_6-2",
    x1: 4043.73,
    y1: 516.14,
    x2: 4054.8,
    y2: 516.14,
    gradientTransform: "matrix(-0.98, -0.2, -0.2, 0.98, 4587.5, 402.45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_6-3",
    x1: 4031.9,
    y1: 521.64,
    x2: 4042.97,
    y2: 521.64,
    gradientTransform: "matrix(-0.98, -0.2, -0.2, 0.98, 4587.5, 402.45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 560.14,
    y1: 361.66,
    x2: 629.74,
    y2: 361.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffca02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fa9a35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#f67160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#f35480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#f14193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f03b9a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 560.15,
    y1: 377.87,
    x2: 629.41,
    y2: 377.87,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 560.12,
    y1: 361.66,
    x2: 629.73,
    y2: 361.66,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_144-7",
    x1: 1446.87,
    y1: 262.6,
    x2: 1460.29,
    y2: 262.6,
    gradientTransform: "matrix(0.92, 0.39, -0.39, 0.92, -889.89, -438.34)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_12",
    x1: 1752.67,
    y1: 364.99,
    x2: 1790.96,
    y2: 364.99,
    gradientTransform: "translate(-1407.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc706"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f14194"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_12-2",
    x1: 1728.09,
    y1: 449.2,
    x2: 1757.8,
    y2: 449.2,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_12-3",
    x1: 1746.55,
    y1: 416.91,
    x2: 1805.64,
    y2: 416.91,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_12-4",
    x1: 1799.99,
    y1: 458.41,
    x2: 1829.64,
    y2: 458.41,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_12-5",
    x1: 1790.63,
    y1: 424.76,
    x2: 1827.09,
    y2: 424.76,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_12-6",
    x1: 1776.73,
    y1: 374.52,
    x2: 1811.19,
    y2: 374.52,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1951.52,
    y1: 375.11,
    x2: 1985.23,
    y2: 375.11,
    gradientTransform: "translate(-1600.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#964ae2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03ffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 1920.96,
    y1: 359.49,
    x2: 1963.11,
    y2: 359.49,
    gradientTransform: "translate(-1600.92)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 1920.96,
    y1: 375.11,
    x2: 1960.88,
    y2: 375.11,
    gradientTransform: "translate(-1600.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#964ae2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#944de2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#8d55e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#8164e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7079ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#5a94ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3fb5f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#20dcf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03ffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_12-7",
    x1: 1772.98,
    y1: 328.19,
    x2: 1801.44,
    y2: 328.19,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_144-8",
    x1: 1776.89,
    y1: 337.6,
    x2: 1797.39,
    y2: 337.6,
    gradientTransform: "translate(-1407.81)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_144-9",
    x1: 1784.54,
    y1: 356.81,
    x2: 1796.71,
    y2: 356.81,
    gradientTransform: "translate(-1407.81)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15-18",
    x1: 1784.54,
    y1: 357.2,
    x2: 1790.75,
    y2: 357.2,
    gradientTransform: "translate(-1407.81)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15-19",
    x1: 1787.22,
    y1: 349.71,
    x2: 1790.72,
    y2: 349.71,
    gradientTransform: "translate(-1407.81)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15-20",
    x1: 1788.78,
    y1: 348.53,
    x2: 1799.5,
    y2: 348.53,
    gradientTransform: "translate(-1407.81)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15-21",
    x1: 1786.49,
    y1: 348.74,
    x2: 1788.8,
    y2: 348.74,
    gradientTransform: "translate(-1407.81)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_144-10",
    x1: 1067.67,
    y1: 585.07,
    x2: 1081.09,
    y2: 585.07,
    gradientTransform: "matrix(0.69, 0.72, -0.72, 0.69, 38.87, -802.64)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_12-8",
    x1: 1768.11,
    y1: 369.73,
    x2: 1806.35,
    y2: 369.73,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_112-11",
    x1: 96,
    y1: 402.7,
    x2: 173.49,
    y2: 402.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_112"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_144-11",
    x1: 112.86,
    y1: 408.68,
    x2: 159.7,
    y2: 408.68,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_144"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 124.94,
    y1: 438.87,
    x2: 147.62,
    y2: 438.87,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 123.94,
    y1: 438.87,
    x2: 148.62,
    y2: 438.87,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 550.18,
    y1: 365.55,
    x2: 496.14,
    y2: 365.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 550.18,
    y1: 365.56,
    x2: 496.14,
    y2: 365.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 460.47,
    y1: 402.76,
    x2: 548.92,
    y2: 402.76,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 459.47,
    y1: 402.76,
    x2: 549.92,
    y2: 402.76,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 488.71,
    y1: 449.32,
    x2: 520.47,
    y2: 449.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 485.65,
    y1: 454.98,
    x2: 523.13,
    y2: 454.98,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 484.65,
    y1: 454.98,
    x2: 524.13,
    y2: 454.98,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 485.65,
    y1: 448.36,
    x2: 523.13,
    y2: 448.36,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 484.65,
    y1: 448.36,
    x2: 524.13,
    y2: 448.36,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 485.65,
    y1: 441.73,
    x2: 523.13,
    y2: 441.73,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 484.65,
    y1: 441.73,
    x2: 524.13,
    y2: 441.73,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 577.64,
    y1: 416.75,
    x2: 612.23,
    y2: 416.75,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 576.64,
    y1: 415.96,
    x2: 613.24,
    y2: 415.96,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 590.08,
    y1: 391.42,
    x2: 599.8,
    y2: 391.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 623.87,
    y1: 360.74,
    x2: 633.59,
    y2: 360.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 556.28,
    y1: 360.74,
    x2: 566,
    y2: 360.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 4142.78,
    y1: 795.67,
    x2: 4268.94,
    y2: 795.67,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 4142.78,
    y1: 798.05,
    x2: 4268.94,
    y2: 798.05,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 4142.79,
    y1: 798.12,
    x2: 4268.94,
    y2: 798.12,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 4142.79,
    y1: 796.22,
    x2: 4268.94,
    y2: 796.22,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 4142.77,
    y1: 792.46,
    x2: 4268.94,
    y2: 792.46,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 4142.81,
    y1: 786.9,
    x2: 4268.94,
    y2: 786.9,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 4142.8,
    y1: 779.84,
    x2: 4268.94,
    y2: 779.84,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 4142.81,
    y1: 771.99,
    x2: 4268.94,
    y2: 771.99,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 4142.79,
    y1: 764.06,
    x2: 4268.94,
    y2: 764.06,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 4142.8,
    y1: 756.46,
    x2: 4268.94,
    y2: 756.46,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 4142.79,
    y1: 749.28,
    x2: 4268.94,
    y2: 749.28,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 4142.79,
    y1: 742.54,
    x2: 4268.94,
    y2: 742.54,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 4142.79,
    y1: 736.24,
    x2: 4268.94,
    y2: 736.24,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 4142.79,
    y1: 730.39,
    x2: 4268.94,
    y2: 730.39,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 4142.79,
    y1: 725.04,
    x2: 4268.94,
    y2: 725.04,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 4142.78,
    y1: 720.25,
    x2: 4268.94,
    y2: 720.25,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 4142.78,
    y1: 716.11,
    x2: 4268.94,
    y2: 716.11,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 4142.79,
    y1: 712.79,
    x2: 4268.94,
    y2: 712.79,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 4142.79,
    y1: 710.51,
    x2: 4268.93,
    y2: 710.51,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 4142.79,
    y1: 709.58,
    x2: 4268.94,
    y2: 709.58,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 4142.79,
    y1: 710.35,
    x2: 4268.93,
    y2: 710.35,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 4142.79,
    y1: 713.04,
    x2: 4268.93,
    y2: 713.04,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 4142.78,
    y1: 717.51,
    x2: 4268.94,
    y2: 717.51,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 4142.79,
    y1: 723.32,
    x2: 4268.94,
    y2: 723.32,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 4142.79,
    y1: 730.32,
    x2: 4268.94,
    y2: 730.32,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 4142.78,
    y1: 738.13,
    x2: 4268.95,
    y2: 738.13,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 4142.79,
    y1: 745.82,
    x2: 4268.91,
    y2: 745.82,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 4142.78,
    y1: 751.02,
    x2: 4268.95,
    y2: 751.02,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 4142.78,
    y1: 750.29,
    x2: 4268.94,
    y2: 750.29,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 4142.79,
    y1: 745.38,
    x2: 4268.93,
    y2: 745.38,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 4142.79,
    y1: 738.86,
    x2: 4268.93,
    y2: 738.86,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 4142.77,
    y1: 731.32,
    x2: 4268.96,
    y2: 731.32,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 4142.8,
    y1: 723.37,
    x2: 4268.93,
    y2: 723.37,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 4142.79,
    y1: 715.98,
    x2: 4268.93,
    y2: 715.98,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 4142.78,
    y1: 710.31,
    x2: 4268.94,
    y2: 710.31,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 4142.78,
    y1: 707.07,
    x2: 4268.95,
    y2: 707.07,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 4142.79,
    y1: 705.68,
    x2: 4268.94,
    y2: 705.68,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 4142.79,
    y1: 706.26,
    x2: 4268.93,
    y2: 706.26,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 4142.79,
    y1: 708.84,
    x2: 4268.94,
    y2: 708.84,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 4142.79,
    y1: 713.24,
    x2: 4268.92,
    y2: 713.24,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 4142.79,
    y1: 719.18,
    x2: 4268.93,
    y2: 719.18,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 4142.79,
    y1: 726.3,
    x2: 4268.9,
    y2: 726.3,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 4142.79,
    y1: 734.11,
    x2: 4268.92,
    y2: 734.11,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 4142.79,
    y1: 742.06,
    x2: 4268.93,
    y2: 742.06,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 4142.79,
    y1: 749.66,
    x2: 4268.93,
    y2: 749.66,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 4142.79,
    y1: 756.61,
    x2: 4268.92,
    y2: 756.61,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 4142.79,
    y1: 762.82,
    x2: 4268.95,
    y2: 762.82,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 4142.79,
    y1: 768.29,
    x2: 4268.93,
    y2: 768.29,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 4142.78,
    y1: 773.11,
    x2: 4268.95,
    y2: 773.11,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 4142.79,
    y1: 777.34,
    x2: 4268.92,
    y2: 777.34,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 4142.78,
    y1: 781.08,
    x2: 4268.94,
    y2: 781.08,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 4142.78,
    y1: 784.29,
    x2: 4268.94,
    y2: 784.29,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 4142.79,
    y1: 786.86,
    x2: 4268.93,
    y2: 786.86,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 4142.8,
    y1: 789.16,
    x2: 4268.93,
    y2: 789.16,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 4142.79,
    y1: 791.35,
    x2: 4268.93,
    y2: 791.35,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 4142.79,
    y1: 793.44,
    x2: 4268.94,
    y2: 793.44,
    gradientTransform: "translate(-1586.67 4091.69) rotate(-76.38)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15-22",
    x1: 1329.18,
    y1: -131.25,
    x2: 1376.87,
    y2: -131.25,
    gradientTransform: "translate(-1069.54 755.24) rotate(-19.68)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15-23",
    x1: 1329.71,
    y1: -131.53,
    x2: 1382.27,
    y2: -131.53,
    gradientTransform: "translate(-1069.54 755.24) rotate(-19.68)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15-24",
    x1: 1339.17,
    y1: -129.53,
    x2: 1371.35,
    y2: -129.53,
    gradientTransform: "translate(-1069.54 755.24) rotate(-19.68)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104",
    x1: 354.09,
    y1: 129.95,
    x2: 394.09,
    y2: 129.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0399c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-2",
    x1: 611.15,
    y1: 210.95,
    x2: 633.51,
    y2: 210.95,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-3",
    x1: 297.33,
    y1: 182.34,
    x2: 319.69,
    y2: 182.34,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-4",
    x1: 552.21,
    y1: 190.32,
    x2: 562.35,
    y2: 190.32,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-5",
    x1: 640.31,
    y1: 287.1,
    x2: 647.18,
    y2: 287.1,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-6",
    x1: 350.66,
    y1: 154.71,
    x2: 357.52,
    y2: 154.71,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-7",
    x1: 201.1,
    y1: 151.27,
    x2: 207.96,
    y2: 151.27,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-8",
    x1: 109.37,
    y1: 341.02,
    x2: 116.23,
    y2: 341.02,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-9",
    x1: 94.48,
    y1: 259.75,
    x2: 99.91,
    y2: 259.75,
    gradientTransform: "translate(212.22 7.39) rotate(45.02)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-10",
    x1: 1383.24,
    y1: 1135.19,
    x2: 1388.67,
    y2: 1135.19,
    gradientTransform: "translate(1879.91 82.43) rotate(135)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-11",
    x1: 532.32,
    y1: 283.33,
    x2: 554.68,
    y2: 283.33,
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-12",
    x1: 549.04,
    y1: 252.71,
    x2: 554.47,
    y2: 252.71,
    gradientTransform: "translate(340.3 -316.13) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-13",
    x1: 1376.2,
    y1: 680.63,
    x2: 1381.63,
    y2: 680.63,
    gradientTransform: "translate(2008.07 -241.06) rotate(135)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-14",
    x1: 1643.65,
    y1: -129.36,
    x2: 1683.65,
    y2: -129.36,
    gradientTransform: "translate(2280.72 120.63) rotate(180)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-15",
    x1: 1760.98,
    y1: 36.9,
    x2: 1800.98,
    y2: 36.9,
    gradientTransform: "translate(2280.72 120.63) rotate(180)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-16",
    x1: 1800.25,
    y1: -9.32,
    x2: 1829.3,
    y2: -9.32,
    gradientTransform: "translate(2280.72 120.63) rotate(180)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-17",
    x1: 1832.33,
    y1: -9.32,
    x2: 1840.25,
    y2: -9.32,
    gradientTransform: "translate(2280.72 120.63) rotate(180)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-18",
    x1: 2040.39,
    y1: -6.21,
    x2: 2062.75,
    y2: -6.21,
    gradientTransform: "translate(2280.72 120.63) rotate(180)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-19",
    x1: 1815.18,
    y1: 27.97,
    x2: 1825.32,
    y2: 27.97,
    gradientTransform: "translate(2280.72 120.63) rotate(180)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-20",
    x1: 1703.07,
    y1: -91.32,
    x2: 1709.93,
    y2: -91.32,
    gradientTransform: "translate(2280.72 120.63) rotate(180)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-21",
    x1: 1845.76,
    y1: 36.9,
    x2: 1852.62,
    y2: 36.9,
    gradientTransform: "translate(2280.72 120.63) rotate(180)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-22",
    x1: 1943.7,
    y1: 33.47,
    x2: 1949.13,
    y2: 33.47,
    gradientTransform: "translate(1686.96 1487.15) rotate(-135)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-24",
    x1: 1156.96,
    y1: -714.03,
    x2: 1162.39,
    y2: -714.03,
    gradientTransform: "translate(19.18 1412.07) rotate(-45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-25",
    x1: 2076.18,
    y1: 21.69,
    x2: 2081.61,
    y2: 21.69,
    gradientTransform: "translate(1656.48 1584.28) rotate(-135)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-27",
    x1: 1145.19,
    y1: -846.52,
    x2: 1150.62,
    y2: -846.52,
    gradientTransform: "translate(-11.28 1509.21) rotate(-45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-28",
    x1: 1949.92,
    y1: -11.03,
    x2: 1978.97,
    y2: -11.03,
    gradientTransform: "translate(2280.72 120.63) rotate(180)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-29",
    x1: 1982,
    y1: -11.03,
    x2: 1989.92,
    y2: -11.03,
    gradientTransform: "translate(2280.72 120.63) rotate(180)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-30",
    x1: 2153.45,
    y1: -236.57,
    x2: 2182.5,
    y2: -236.57,
    gradientTransform: "translate(2280.72 120.63) rotate(180)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-31",
    x1: 2185.53,
    y1: -236.57,
    x2: 2193.45,
    y2: -236.57,
    gradientTransform: "translate(2280.72 120.63) rotate(180)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-32",
    x1: 2168.44,
    y1: -117.11,
    x2: 2190.81,
    y2: -117.11,
    gradientTransform: "translate(2280.72 120.63) rotate(180)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-33",
    x1: 2099.34,
    y1: 7.5,
    x2: 2128.4,
    y2: 7.5,
    gradientTransform: "translate(2280.72 120.63) rotate(180)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-34",
    x1: 2131.42,
    y1: 7.5,
    x2: 2139.34,
    y2: 7.5,
    gradientTransform: "translate(2280.72 120.63) rotate(180)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-35",
    x1: 2007.9,
    y1: -10.03,
    x2: 2013.33,
    y2: -10.03,
    gradientTransform: "translate(1698.91 1545.29) rotate(-135)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-37",
    x1: 1113.47,
    y1: -778.23,
    x2: 1118.9,
    y2: -778.23,
    gradientTransform: "translate(31.29 1470.24) rotate(-45.01)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-38",
    x1: 1904.46,
    y1: 7.5,
    x2: 1909.89,
    y2: 7.5,
    gradientTransform: "translate(1716.77 1467.06) rotate(-135)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-40",
    x1: 1130.99,
    y1: -674.8,
    x2: 1136.42,
    y2: -674.8,
    gradientTransform: "translate(49.2 1391.98) rotate(-45.01)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-41",
    x1: 1871.14,
    y1: 26.97,
    x2: 1900.19,
    y2: 26.97,
    gradientTransform: "translate(2280.72 120.63) rotate(180)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-42",
    x1: 1903.22,
    y1: 26.97,
    x2: 1911.14,
    y2: 26.97,
    gradientTransform: "translate(2280.72 120.63) rotate(180)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-43",
    x1: 1807.75,
    y1: 11.22,
    x2: 1813.18,
    y2: 11.22,
    gradientTransform: "translate(1742.51 1397.54) rotate(-135)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-45",
    x1: 1134.71,
    y1: -578.08,
    x2: 1140.14,
    y2: -578.08,
    gradientTransform: "translate(74.88 1322.51) rotate(-45.01)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-46",
    x1: 1655.67,
    y1: -108.61,
    x2: 1661.1,
    y2: -108.61,
    gradientTransform: "translate(1871.82 1325.05) rotate(-135)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104-47",
    x1: 1014.89,
    y1: -426,
    x2: 1020.32,
    y2: -426,
    gradientTransform: "translate(204.01 1250.02) rotate(-45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_104"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 900,
    height: 600
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M653.92,358.07a58.93,58.93,0,0,0-4.6-24l8.53-5.61-11.83-18L637.49,316a58.36,58.36,0,0,0-15.43-11.53c-1.5-.79-3.06-1.51-4.64-2.15a1,1,0,0,0-.2-.08l2.09-10-21.1-4.37-2.07,10a59.49,59.49,0,0,0-6.56.23,58.12,58.12,0,0,0-17.49,4.36L566.47,294l-18,11.83,5.6,8.52a58.91,58.91,0,0,0-13.76,20.27l-10-2.07L526,353.61l10,2.07a58.66,58.66,0,0,0,4.59,24.06l-8.52,5.6,11.82,18,8.54-5.61a58.5,58.5,0,0,0,20.26,13.76l-2.07,10,21.08,4.36,2.07-10a65.14,65.14,0,0,0,6.58-.23,58.9,58.9,0,0,0,17.48-4.37l5.61,8.53,18-11.84-5.6-8.53a58.52,58.52,0,0,0,13.75-20.26l10,2.07,4.37-21.09Zm-16.32,7.64a43.62,43.62,0,1,1-26.69-49.34,38.48,38.48,0,0,1,4.65,2.13A43.6,43.6,0,0,1,637.6,365.71ZM595,401.44a44.56,44.56,0,1,1,16.31-86,37.16,37.16,0,0,1,4.76,2.19,44.83,44.83,0,0,1,22.54,48.28h0A44.31,44.31,0,0,1,599,401.26Q597,401.44,595,401.44Zm-.06-87.13q-1.92,0-3.84.18a42.56,42.56,0,0,0-4.75,84.06,42.84,42.84,0,0,0,12.49.72,42.33,42.33,0,0,0,37.81-33.77h0a42.82,42.82,0,0,0-21.53-46.11,36.37,36.37,0,0,0-4.53-2.09,43.92,43.92,0,0,0-7-2.1A42.59,42.59,0,0,0,594.91,314.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "681.58 330.94 637.27 433 429.37 433 385.06 330.94 681.58 330.94"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 241.8,
    y: 141.19,
    width: 9.01,
    height: 291.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M250.81,434h-9a1,1,0,0,1-1-1V141.19a1,1,0,0,1,1-1h9a1,1,0,0,1,1,1V433A1,1,0,0,1,250.81,434Zm-8-2h7V142.19h-7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "185.87 433.01 234.94 154.71 225.8 154.71 176.72 433.01 185.87 433.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M185.87,434h-9.15a1,1,0,0,1-.76-.36,1,1,0,0,1-.22-.82l49.07-278.3a1,1,0,0,1,1-.82h9.14a1,1,0,0,1,1,1.17l-49.07,278.3A1,1,0,0,1,185.87,434Zm-8-2H185l48.72-276.3h-7.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "315.89 433.01 266.81 154.71 257.67 154.71 306.74 433.01 315.89 433.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M315.89,434h-9.15a1,1,0,0,1-1-.83l-49.07-278.3a1,1,0,0,1,.21-.82,1,1,0,0,1,.77-.35h9.14a1,1,0,0,1,1,.82l49.07,278.3a1,1,0,0,1-.22.82A1,1,0,0,1,315.89,434Zm-8.31-2h7.12L266,155.71h-7.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 211.34,
    y: 190.12,
    width: 69.93,
    height: 9.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M281.27,200.13H211.34a1,1,0,0,1-1-1v-9a1,1,0,0,1,1-1h69.93a1,1,0,0,1,1,1v9A1,1,0,0,1,281.27,200.13Zm-68.93-2h67.93v-7H212.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 211.34,
    y: 356.76,
    width: 69.93,
    height: 9.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M281.27,366.76H211.34a1,1,0,0,1-1-1v-9a1,1,0,0,1,1-1h69.93a1,1,0,0,1,1,1v9A1,1,0,0,1,281.27,366.76Zm-68.93-2h67.93v-7H212.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 160.45,
    y: 347.75,
    width: 171.72,
    height: 9.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M332.16,357.76H160.45a1,1,0,0,1-1-1v-9a1,1,0,0,1,1-1H332.16a1,1,0,0,1,1,1v9A1,1,0,0,1,332.16,357.76Zm-170.71-2H331.16v-7H161.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 127.97,
    y: 199.13,
    width: 236.67,
    height: 148.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M365.64,348.75H127V198.13H365.64Zm-236.67-2H363.64V200.13H129Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M234.29,234a5.15,5.15,0,1,1-5.15-5.14A5.14,5.14,0,0,1,234.29,234Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M218.86,259.75a5.15,5.15,0,0,0,0-10.29H203.43a5.15,5.15,0,1,1,0-10.29h5.14a5.14,5.14,0,0,0,0-10.28H179.06a5.14,5.14,0,1,0,0,10.28h5.14a5.15,5.15,0,0,1,0,10.29H168.77a5.15,5.15,0,0,0,0,10.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M250,316.56a5.15,5.15,0,1,1-5.15-5.14A5.15,5.15,0,0,1,250,316.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M224.26,321.71a5.15,5.15,0,0,0,0-10.29H177.84a5.15,5.15,0,0,0,0,10.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M260.6,249.77a7.89,7.89,0,1,0,0,15.78h7.08a7.89,7.89,0,0,1,0,15.78H244.81a7.89,7.89,0,0,0,0,15.78H304a7.89,7.89,0,0,0,0-15.78h-6.86a7.89,7.89,0,0,1,0-15.78h31.56a7.89,7.89,0,0,0,0-15.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M685,433H68A15.94,15.94,0,0,0,52,448.94h0A15.94,15.94,0,0,0,68,464.88h93.31a15.93,15.93,0,0,1,15.93,15.93h0a15.93,15.93,0,0,1-15.93,15.94H142a15.94,15.94,0,0,0-15.94,15.94h0A15.93,15.93,0,0,0,142,528.62H674.78a15.93,15.93,0,0,0,15.93-15.93h0a15.94,15.94,0,0,0-15.93-15.94h-2.5a15.94,15.94,0,0,1-15.94-15.94h0a15.94,15.94,0,0,1,15.94-15.93H685A15.94,15.94,0,0,0,701,448.94h0A15.94,15.94,0,0,0,685,433Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 478.18,
    y: 460.68,
    width: 88.2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 204.24,
    y: 441.77,
    width: 195.35,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 444.45,
    y: 460.68,
    width: 17.73,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 579.38,
    y: 479.2,
    width: 51.77,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 559.59,
    y: 479.2,
    width: 10.41,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 575.45,
    y: 442.95,
    width: 30.15,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 616.79,
    y: 442.95,
    width: 10.23,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 563.91,
    y: 442.95,
    width: 6.06,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 404.01,
    y: 469.66,
    width: 30.15,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 445.35,
    y: 469.66,
    width: 10.23,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 392.48,
    y: 469.66,
    width: 6.06,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 262.02,
    y: 459.68,
    width: 58.4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 342.09,
    y: 459.68,
    width: 19.82,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 239.69,
    y: 459.68,
    width: 11.74,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 108.11,
    y: 453.01,
    width: 25.18,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 145.21,
    y: 453.01,
    width: 10.9,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M337.28,300.57v35.71A33.68,33.68,0,0,0,371,370h27.83l26.46,63.2H528.14l-38.08-112.3c39.64-24.2,45.25-54.91,42.76-90.16-2.68-37.79-32.12-90.32-94.69-90.32-59.49,0-102.87,39-102.87,97.84,0,4.24.29,17,.78,21.15l-21.3,41.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M529.53,434.16H424.58l-.26-.61L398.13,371H371a34.72,34.72,0,0,1-34.68-34.68V301.57H313.1L335,259.18c-.47-4.37-.75-16.57-.75-21,0-58.19,42.72-98.84,103.87-98.84,35.81,0,58.14,17,70.56,31.33,14.24,16.39,23.63,38.78,25.13,59.92,2.26,32-1.34,65.17-42.56,90.67Zm-103.62-2H526.74L488.85,320.42l.69-.41c38.66-23.6,44.86-52.75,42.28-89.24-2.44-34.56-30-89.39-93.69-89.39-60,0-101.87,39.82-101.87,96.84,0,4.46.29,17,.77,21l0,.31-20.69,40h21.9v36.71A32.72,32.72,0,0,0,371,369h28.5l.25.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M348.87,220.13c0-7.85,6.64-14.21,14.84-14.21a15.36,15.36,0,0,1,2.16.15,14,14,0,0,1-5.44-11c0-7.85,6.65-14.21,14.84-14.21a15.31,15.31,0,0,1,7.43,1.9,13.66,13.66,0,0,1-1.73-6.65c0-7.85,6.64-14.21,14.84-14.21a15.05,15.05,0,0,1,11.64,5.4,14.09,14.09,0,0,1-.19-2.27c0-7.84,6.64-14.21,14.84-14.21a14.93,14.93,0,0,1,13.34,8,14.9,14.9,0,0,1,13.33-8c8.2,0,14.84,6.37,14.84,14.21a14.56,14.56,0,0,1-.08,1.49,15.12,15.12,0,0,1,11-4.62c8.2,0,14.84,6.36,14.84,14.21a13.61,13.61,0,0,1-1.56,6.34,15.42,15.42,0,0,1,6.83-1.59c8.2,0,14.84,6.36,14.84,14.21a13.93,13.93,0,0,1-5.27,10.85c7.94.29,14.28,6.53,14.28,14.2a14.45,14.45,0,0,1-13.21,14.12l0,.09H363.71C355.51,234.34,348.87,228,348.87,220.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M435.75,156.28a17,17,0,0,0-19.09-5.8,15.59,15.59,0,0,0-10.53,13.61,17.12,17.12,0,0,0-19.54-.76,15.19,15.19,0,0,0-6.37,17A16.81,16.81,0,0,0,362,185.92a15.05,15.05,0,0,0,.37,18.66c-8.09.68-14.89,6.83-15.13,15.46.25,9.17,7.91,15.59,16.84,15.59h10.05c15.34,0,132.52-.09,132.52-.09,8-1.33,14.23-7.8,14-16.26-.21-7.36-6-12.8-12.79-14.37a15.24,15.24,0,0,0,.85-18.71c-4.09-5.81-11.44-7.72-18-6a15.13,15.13,0,0,0-5.8-16.44,17.08,17.08,0,0,0-19.52-.11,16.09,16.09,0,0,0-10.56-13.16C448,147.82,440.05,150.56,435.75,156.28Zm46.52,9.1a12.51,12.51,0,0,1,4.93,16.31,17.39,17.39,0,0,1-5.66,4.14c-5.82,2.81-12,.59-16.81-3.06-1.47-1.09-2.87,1.37-1.43,2.45a24.43,24.43,0,0,0,7,3.72c-5,5.92-6.26,14.21-1.48,20.75,1.07,1.45,3.52,0,2.44-1.43-4.39-6-2.85-13.46,2.18-18.57a16.42,16.42,0,0,0,8.23-.85,18.79,18.79,0,0,0,7.61-5.2,14.26,14.26,0,0,1,16.8,3.71c4.65,5.38,2.93,13.22-2.15,17.54a1.21,1.21,0,0,0-.42.7c-6.86,2-14.65.9-18.67-5.66-.94-1.55-3.39-.13-2.44,1.43,5.11,8.37,15.62,9.62,24.19,6.15,5.92,1,10.74,5.52,11.27,11.77.58,7-5.28,12.58-11.86,13.43a2.59,2.59,0,0,0-.4.09h-10l-.94-.82a20.94,20.94,0,0,1-2.71-3.16,13,13,0,0,1-2.15-11.46,1.42,1.42,0,0,0-2.73-.75,15,15,0,0,0-.46,6.15,13.2,13.2,0,0,1-7.27-8.12,1.42,1.42,0,0,0-2.73.75,16.36,16.36,0,0,0,10.8,10.72,19.68,19.68,0,0,0,4.07,6.69H447.94a30.57,30.57,0,0,0-.8-25.61c-.81-1.64-3.25-.2-2.44,1.42a27.66,27.66,0,0,1,2.72,9.52c-3.85-1.94-8.83-1.11-12.65.57-1.67.72-.22,3.16,1.43,2.44,3.43-1.5,8.3-2.23,11.35.5a25.78,25.78,0,0,1-2.74,11.16H412.2c-4.2-6.8-1.25-15.49,3.44-21.22,1.15-1.39-.84-3.41-2-2A30,30,0,0,0,409,217.4c-2.52-2-6.09-2.15-9.15-1.2-1.74.54-1,3.27.75,2.73a7.34,7.34,0,0,1,5.9.23,6.93,6.93,0,0,1,1.52,1.23A17.72,17.72,0,0,0,409,232.8H365.81c-7,0-13.59-2.71-15.47-10.19a11.62,11.62,0,0,1-.27-2.57c.23-8.38,7.77-13.43,15.69-12.6a15.45,15.45,0,0,1,6.2,2.13c5.11,3,6.86,8.82,6.94,14.44a1.42,1.42,0,0,0,2.83,0c-.13-9.28-5.52-18.4-15.37-19.35-4.83-4.28-6.07-10.86-2.55-16.44,3.74-6,11.86-7.24,17.87-4.34a16.51,16.51,0,0,0,9.82,7.74c-.55,4-2.91,8.08-7,9.18a1.42,1.42,0,0,0,.75,2.73c5.19-1.39,8.24-6.23,9-11.33a19.45,19.45,0,0,0,9.45-1.2c1.68-.65.95-3.39-.75-2.73-7.19,2.79-15.22.88-19-6.19a12.56,12.56,0,0,1,4.72-16.7c5.73-3.62,13.25-2.08,17.71,2.73a17.1,17.1,0,0,0,4.7,7.52,12.24,12.24,0,0,0,5.41,3,14,14,0,0,0,7,14.79,18.61,18.61,0,0,0-5.47,5.37c-1,1.51,1.42,2.93,2.44,1.42,1.35-2,4.18-4,6.77-5.33a1.06,1.06,0,0,0,.53-.26l.25-.11a23.65,23.65,0,0,1,13.24-1.56,2.16,2.16,0,0,0,.38.06,47.86,47.86,0,0,1,13,4.24c1.64.78,3.07-1.66,1.43-2.44a53.44,53.44,0,0,0-7.69-2.93c10-3.35,16-13.68,17-24.47,0-.05,0-.1,0-.15A14.29,14.29,0,0,1,482.27,165.38Zm-19.67,1.21a1.3,1.3,0,0,0,0,.49,2.5,2.5,0,0,0,0,.29,35,35,0,0,1-3.18,10.95c-3.43,7.19-9.67,11.7-17.75,11.82a1.39,1.39,0,0,0-.63.15,29,29,0,0,0-14.45,1.49c-5.26-2.13-8.39-7.13-7.33-12.78a23.2,23.2,0,0,0,10.05-2.11c1.68-.71.24-3.15-1.42-2.44-5.23,2.23-11.14,2.88-15.46-1.4A13.82,13.82,0,0,1,409,167c-.9-6.42,3.18-12,9.18-14a13.92,13.92,0,0,1,16.09,6.12c-2.31,8.71,2.59,16.73,10.79,20,1.7.67,2.43-2.06.75-2.73-6.93-2.73-10.8-9.61-8.7-16.88C443.91,147.38,463.79,152.14,462.6,166.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M402.44,112.35v-.15a2.19,2.19,0,0,1,.39-1.27,2.22,2.22,0,0,1,1.24-.86l9.92-6.9a2.22,2.22,0,0,1,3.07.55,2.27,2.27,0,0,1-.55,3.07l-7.9,5.48,7.9,5.49a2.26,2.26,0,0,1,.55,3.06,2.21,2.21,0,0,1-3.07.56l-9.92-6.9a2.19,2.19,0,0,1-1.24-.87A2.16,2.16,0,0,1,402.44,112.35Zm2,0-1,0h1a.25.25,0,0,0,0,.12.22.22,0,0,0,.13.08l.24,0,10.29,7.15a.2.2,0,0,0,.29,0c0-.06.13-.16-.05-.27l-10.26-7.14,10.26-7.13c.18-.12.09-.22.05-.28a.22.22,0,0,0-.29,0L404.85,112l-.24,0a.17.17,0,0,0-.14.08s0,0,0,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M413.24,112.35v-.16a2.16,2.16,0,0,1,.39-1.26,2.22,2.22,0,0,1,1.24-.86l9.92-6.9a2.21,2.21,0,0,1,3.06.55,2.27,2.27,0,0,1-.54,3.07l-7.9,5.48,7.9,5.49a2.25,2.25,0,0,1,.54,3.07,2.19,2.19,0,0,1-1.41.91,2.24,2.24,0,0,1-1.65-.36l-9.92-6.9a2.19,2.19,0,0,1-1.24-.87A2.16,2.16,0,0,1,413.24,112.35Zm2,0h0a.17.17,0,0,0,0,.12.21.21,0,0,0,.13.08l.24,0,10.29,7.15a.26.26,0,0,0,.15,0,.21.21,0,0,0,.13-.09c.05-.07.13-.16,0-.28l-10.27-7.13,10.27-7.13c.17-.12.09-.21,0-.27a.2.2,0,0,0-.28-.06L415.64,112l-.23,0a.17.17,0,0,0-.14.08.15.15,0,0,0,0,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M424,111.9v-.18a2.2,2.2,0,0,1,.39-1.25,2.29,2.29,0,0,1,1.24-.87l9.92-6.89a2.22,2.22,0,0,1,3.07.55,2.25,2.25,0,0,1-.55,3.06l-7.9,5.49,7.9,5.49a2.25,2.25,0,0,1,.55,3.06,2.21,2.21,0,0,1-3.07.56L425.66,114A2.19,2.19,0,0,1,424,111.9Zm2,0-1,0h1a.2.2,0,0,0,0,.1.22.22,0,0,0,.14.09l.24,0,10.28,7.15a.2.2,0,0,0,.29,0c0-.06.13-.16-.05-.28l-10.26-7.13L437,104.68c.18-.12.09-.22.05-.28a.23.23,0,0,0-.3-.05l-10.27,7.15-.24,0a.21.21,0,0,0-.13.08.18.18,0,0,0,0,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M434.83,111.9v-.18a2.21,2.21,0,0,1,.38-1.24,2.26,2.26,0,0,1,1.24-.87l9.93-6.9a2.22,2.22,0,0,1,3.07.55,2.26,2.26,0,0,1-.56,3.07L441,111.81l7.9,5.49a2.25,2.25,0,0,1,.55,3.06,2.21,2.21,0,0,1-3.07.55l-9.93-6.9a2.15,2.15,0,0,1-1.23-.86A2.2,2.2,0,0,1,434.83,111.9Zm2,0h0a.19.19,0,0,0,0,.12.2.2,0,0,0,.13.07l.23,0,10.29,7.15a.23.23,0,0,0,.29,0c0-.06.12-.16-.05-.28l-10.26-7.13,10.25-7.13c.19-.12.1-.22.06-.28a.22.22,0,0,0-.29-.05l-10.29,7.15-.23,0a.2.2,0,0,0-.14.09.15.15,0,0,0,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M249.12,115.75a16.13,16.13,0,0,1-11.06-4.26,10.77,10.77,0,0,0-14.4,0,2.92,2.92,0,0,1-4-.14,2.85,2.85,0,0,1,.14-4,16.51,16.51,0,0,1,22.14,0,10.76,10.76,0,0,0,14.39,0,16.51,16.51,0,0,1,22.14,0,10.76,10.76,0,0,0,14.39,0,16.5,16.5,0,0,1,22.13,0,2.84,2.84,0,0,1,.15,4,2.93,2.93,0,0,1-4,.14,10.76,10.76,0,0,0-14.39,0,16.5,16.5,0,0,1-22.13,0,10.77,10.77,0,0,0-14.4,0A16.15,16.15,0,0,1,249.12,115.75Zm-18.26-9a12.5,12.5,0,0,1,8.56,3.3,14.52,14.52,0,0,0,19.41,0A12.75,12.75,0,0,1,276,110a14.52,14.52,0,0,0,19.41,0,12.74,12.74,0,0,1,17.11,0,.87.87,0,0,0,1.2,0,.85.85,0,0,0-.05-1.19,14.52,14.52,0,0,0-19.41,0,12.74,12.74,0,0,1-17.11,0,14.52,14.52,0,0,0-19.41,0,12.75,12.75,0,0,1-17.12,0,14.52,14.52,0,0,0-19.41,0,.85.85,0,0,0,0,1.19.87.87,0,0,0,1.19,0A12.5,12.5,0,0,1,230.86,106.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M587.52,274.85a16.17,16.17,0,0,1-11.07-4.26,10.76,10.76,0,0,0-14.39,0,2.93,2.93,0,0,1-4-.14,2.85,2.85,0,0,1,.15-4,16.5,16.5,0,0,1,22.13,0,10.77,10.77,0,0,0,14.4,0,16.5,16.5,0,0,1,22.13,0,10.77,10.77,0,0,0,14.4,0,16.5,16.5,0,0,1,22.13,0,2.85,2.85,0,0,1,.15,4,2.93,2.93,0,0,1-4,.14,10.76,10.76,0,0,0-14.39,0,16.51,16.51,0,0,1-22.14,0,10.76,10.76,0,0,0-14.39,0A16.17,16.17,0,0,1,587.52,274.85Zm-18.26-9a12.5,12.5,0,0,1,8.56,3.3,14.52,14.52,0,0,0,19.41,0,12.74,12.74,0,0,1,17.11,0,14.53,14.53,0,0,0,19.42,0,12.74,12.74,0,0,1,17.11,0,.85.85,0,0,0,1.19-.05.83.83,0,0,0,0-1.18,14.49,14.49,0,0,0-19.41,0,12.78,12.78,0,0,1-17.12,0,14.49,14.49,0,0,0-19.41,0,12.78,12.78,0,0,1-17.12,0,14.49,14.49,0,0,0-19.41,0,.84.84,0,0,0,0,1.19.88.88,0,0,0,1.19,0A12.48,12.48,0,0,1,569.26,265.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M99.54,295.44a10.85,10.85,0,0,0-10.93,10.81c0,10.28,11,21.15,11,21.15s11-11,11-21.15C110.52,299.49,104.47,295.44,99.54,295.44Zm2.71,15.44a5.15,5.15,0,0,1-2.69.73,5,5,0,0,1-3.49-1.35c-3.07-2.84-1.9-9.42,3.51-9.42C105.44,300.84,106.33,308.54,102.25,310.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M99.57,328.82l-.71-.71c-.46-.45-11.25-11.28-11.25-21.86a11.9,11.9,0,0,1,11.93-11.81c5.78,0,12,4.74,12,11.81,0,10.4-10.79,21.39-11.25,21.86Zm0-32.38a9.89,9.89,0,0,0-9.93,9.81c0,8.26,7.56,17.11,10,19.7,2.38-2.62,10-11.59,10-19.7C109.52,299.85,103.72,296.44,99.54,296.44Zm0,16.17a6,6,0,0,1-4.2-1.63,6.78,6.78,0,0,1-1.5-7.34,6.18,6.18,0,0,1,11.65.72,6.58,6.58,0,0,1-2.77,7.38A6,6,0,0,1,99.58,312.61Zm0-10.77a3.85,3.85,0,0,0-3.84,2.53,4.84,4.84,0,0,0,1,5.16,4,4,0,0,0,2.83,1.08,4.16,4.16,0,0,0,2.15-.58h0a4.58,4.58,0,0,0,1.84-5.14A3.9,3.9,0,0,0,99.58,301.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M222.42,432.13c-.78-.31-15.58-9.75-15.58-9.75s14.36-9,15.58-9.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M223.42,412.76v19.37a1,1,0,0,1-.44.82,1,1,0,0,1-.93.11c-.8-.32-12.26-7.61-15.75-9.83a.91.91,0,0,1-.46-.85,1,1,0,0,1,.47-.84c1.47-.93,14.44-9.08,15.68-9.68a1,1,0,0,1,1,.06A1,1,0,0,1,223.42,412.76Zm-2,17.63V414.5c-2.64,1.59-8.27,5.1-12.71,7.89C213.06,425.16,218.79,428.78,221.42,430.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "214.34 417.77 214.31 427.05 206.84 422.38 214.34 417.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M215.33,417.76h0l0,9.28a1,1,0,0,1-1.53.85l-7.47-4.67a1,1,0,0,1-.47-.85h0a1,1,0,0,1,.47-.85l7.5-4.62a1,1,0,0,1,1,0A1,1,0,0,1,215.33,417.76Zm-2,7.49,0-5.69-4.59,2.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "222.98 431.92 223.03 412.71 371.3 412.75 371.3 431.92 222.98 431.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M372.3,412.75v19.17a1,1,0,0,1-1,1H223a1,1,0,0,1-.71-.29,1,1,0,0,1-.29-.71h0l.06-19.21a1,1,0,0,1,1-1l148.26,0A1,1,0,0,1,372.3,412.75Zm-2,18.17V413.75l-146.27,0L224,430.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "222.98 425.61 223.03 419.02 371.3 419.03 371.3 425.61 222.98 425.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M372.3,419v6.58a1,1,0,0,1-1,1H223a1,1,0,0,1-1-1L222,419a1,1,0,0,1,1-1H371.3A1,1,0,0,1,372.3,419Zm-2,5.58V420H224l-.05,4.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M377.79,412.77H371.3v19.15h6.49a9.48,9.48,0,0,0,9.49-9.48v-.19A9.48,9.48,0,0,0,377.79,412.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M377.79,432.92H371.3a1,1,0,0,1-1-1V412.77a1,1,0,0,1,1-1h6.49a10.5,10.5,0,0,1,10.49,10.48v.19A10.5,10.5,0,0,1,377.79,432.92Zm-5.49-2h5.49a8.49,8.49,0,0,0,8.49-8.48v-.19a8.49,8.49,0,0,0-8.49-8.48H372.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M334.3,154.74v.15a2.17,2.17,0,0,1-1.63,2.13l-9.92,6.9a2.22,2.22,0,0,1-3.07-.55,2.27,2.27,0,0,1,.56-3.07l7.89-5.48-7.9-5.49a2.26,2.26,0,0,1-.55-3.06,2.21,2.21,0,0,1,3.07-.56l9.92,6.9a2.19,2.19,0,0,1,1.63,2.13Zm-2,0,1,0h-1a.17.17,0,0,0,0-.12.2.2,0,0,0-.13-.08l-.24,0-10.29-7.15a.2.2,0,0,0-.28,0c0,.06-.13.16,0,.28l10.26,7.13L321.38,162c-.19.12-.1.22-.05.28a.22.22,0,0,0,.29.05l10.28-7.15.24,0a.16.16,0,0,0,.13-.08s0,0,0-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M323.51,154.74v.16a2.23,2.23,0,0,1-.39,1.26,2.21,2.21,0,0,1-1.24.86l-9.93,6.9a2.21,2.21,0,0,1-3.06-.55,2.25,2.25,0,0,1,.55-3.06l7.9-5.49-7.9-5.49a2.25,2.25,0,0,1-.55-3.07,2.17,2.17,0,0,1,1.41-.9,2.15,2.15,0,0,1,1.65.36l9.92,6.89a2.18,2.18,0,0,1,1.64,2.13Zm-2,0,1,0h-1a.17.17,0,0,0,0-.12.19.19,0,0,0-.13-.08l-.24,0-10.29-7.15a.18.18,0,0,0-.15,0,.16.16,0,0,0-.13.08c0,.07-.13.16.05.28l10.26,7.13L310.58,162c-.18.12-.09.22-.05.28a.22.22,0,0,0,.29.05l10.28-7.15.24,0a.29.29,0,0,0,.14-.09.24.24,0,0,0,0-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M312.71,155.19v.18a2.13,2.13,0,0,1-.39,1.25,2.2,2.2,0,0,1-1.24.87l-9.92,6.89a2.22,2.22,0,0,1-3.07-.55,2.26,2.26,0,0,1,.55-3.06l7.9-5.49-7.9-5.48a2.27,2.27,0,0,1-.55-3.07,2.21,2.21,0,0,1,3.07-.55l9.92,6.9a2.13,2.13,0,0,1,1.24.87A2.08,2.08,0,0,1,312.71,155.19Zm-2,0,1,0h-1a.13.13,0,0,0,0-.1.22.22,0,0,0-.14-.09l-.24,0L300,147.82a.2.2,0,0,0-.28.05c-.05.06-.13.16,0,.28L310,155.28l-10.26,7.13c-.17.12-.09.22,0,.28a.21.21,0,0,0,.3.05l10.27-7.15.24,0a.21.21,0,0,0,.14-.08.14.14,0,0,0,0-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M301.91,155.19v.18a2.19,2.19,0,0,1-1.62,2.12l-9.93,6.9a2.21,2.21,0,0,1-3.07-.56,2.26,2.26,0,0,1,.56-3.06l7.89-5.49-7.89-5.48a2.27,2.27,0,0,1-.56-3.07,2.19,2.19,0,0,1,1.42-.91,2.15,2.15,0,0,1,1.65.36l9.93,6.9a2.22,2.22,0,0,1,1.24.86A2.26,2.26,0,0,1,301.91,155.19Zm-2,0,1,0h-1a.27.27,0,0,0,0-.12.23.23,0,0,0-.13-.07l-.24,0-10.29-7.15a.22.22,0,0,0-.28.05c0,.06-.13.16.05.28l10.26,7.13L289,162.41c-.18.13-.09.22-.05.28a.2.2,0,0,0,.28.05l10.29-7.15.24,0a.22.22,0,0,0,.14-.09.25.25,0,0,0,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M563.05,147l1.63.9,2,1.08c.38.22.81.44,1.24.7l1.32.94,3.1,2.2c1.07.87,2.18,1.87,3.39,2.91a41.85,41.85,0,0,1,3.64,3.57l1.9,2,1.79,2.27,1.87,2.37c.62.82,1.16,1.72,1.76,2.6l1.77,2.72c.61.93,1.07,1.94,1.62,2.93l1.63,3c.56,1.07,1,2.1,1.49,3.17.94,2.22,1.83,4.49,2.57,6.85a69.77,69.77,0,0,1,3.17,15,59.86,59.86,0,0,1-.53,15.85,42.34,42.34,0,0,1-5.52,15,30.1,30.1,0,0,1-11.2,10.8l-1.71.85-.11,0-.05,0-.13.06-.21.07L579,245l-.84.31a12.1,12.1,0,0,1-1.73.58l-1.88.41a10,10,0,0,1-1.85.24l-1.82.15c-1.2-.08-2.39-.06-3.55-.23A31.86,31.86,0,0,1,555.24,242a46.58,46.58,0,0,1-8.49-6.64,66.72,66.72,0,0,1-5.52-6.13c-.7-.9-1.33-1.71-1.85-2.42L538.12,225l-1-1.55,1.18,1.45c.38.47.85,1.06,1.41,1.74l2,2.26a65.8,65.8,0,0,0,5.84,5.68,50.26,50.26,0,0,0,8.59,6,31.09,31.09,0,0,0,11.5,3.72,21.46,21.46,0,0,0,12.78-2.76,28.2,28.2,0,0,0,10-10,39.65,39.65,0,0,0,5-14,57.21,57.21,0,0,0,.6-15.06,72.37,72.37,0,0,0-2.8-14.44c-.67-2.3-1.51-4.5-2.31-6.64-.46-1.06-.89-2.19-1.37-3.16s-1-2-1.47-3-.93-2-1.48-2.9L585,169.6c-.54-.89-1-1.79-1.59-2.62l-1.71-2.39c-.57-.78-1.12-1.55-1.65-2.3s-1.19-1.39-1.75-2.06a42.67,42.67,0,0,0-3.34-3.72c-1.12-1.09-2.15-2.15-3.15-3.08l-2.89-2.35-1.25-1c-.41-.3-.81-.55-1.18-.8L564.6,148Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M586.33,159.55s.37.28,1,.81,1.41,1.29,2.32,2.26a21,21,0,0,1,1.45,1.6c.47.62,1,1.28,1.44,2s1,1.42,1.47,2.17a18.57,18.57,0,0,1,1.33,2.34c.4.8.81,1.6,1.18,2.41s.73,1.55,1,2.4c.55,1.57,1,3,1.35,4.35s.47,2.46.58,3.24.13,1.24.13,1.24-.27-.37-.69-1-1-1.61-1.61-2.77c-.33-.57-.71-1.19-1.08-1.86s-.75-1.37-1.12-2.11-.83-1.42-1.22-2.17-.82-1.51-1.22-2.28-.76-1.56-1.19-2.29-.81-1.47-1.19-2.19-.72-1.42-1-2.1-.71-1.31-1-1.9c-.63-1.18-1.1-2.2-1.42-2.93S586.33,159.55,586.33,159.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M568.09,158.38s.46.37,1.23,1,1.85,1.64,3.09,2.86,2.64,2.66,4.11,4.25c.67.85,1.32,1.79,2,2.72s1.32,1.92,2,2.89,1.29,2,1.9,2.94A21.57,21.57,0,0,1,584,178c.9,2,1.72,3.86,2.35,5.49s1.12,3,1.44,4,.46,1.53.46,1.53-.38-.45-1-1.27-1.48-2-2.43-3.43-2-3.12-3.13-5a31.44,31.44,0,0,0-1.82-2.72c-.64-.9-1.26-1.84-1.89-2.78s-1.24-1.89-1.82-2.84l-1.72-2.79c-1.28-1.75-2.44-3.39-3.39-4.85s-1.7-2.69-2.22-3.58S568.09,158.38,568.09,158.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M560.22,151.46s-12.18-29.87-22.14-16.2S560.22,151.46,560.22,151.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "537.73 103.87 518.03 103.58 530.9 113.01 533.96 115.24 542.2 103.98 537.73 103.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M534,116.24a1,1,0,0,1-.59-.19l-15.92-11.67a1,1,0,0,1-.36-1.12,1,1,0,0,1,1-.68l19.71.29h0l4.47.11a1,1,0,0,1,.87.56,1,1,0,0,1-.09,1l-8.25,11.26A1,1,0,0,1,534,116.24Zm-12.8-11.62,12.59,9.22,6.53-8.91-2.56-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "508 144.47 509.51 148.62 517.65 137.5 514.6 135.27 501.72 125.84 508 144.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M509.51,149.62h-.14a1,1,0,0,1-.8-.65l-1.51-4.15v0l-6.27-18.63a1,1,0,0,1,.35-1.13,1,1,0,0,1,1.18,0l15.93,11.67a1,1,0,0,1,.4.65,1,1,0,0,1-.18.75l-8.14,11.11A1,1,0,0,1,509.51,149.62Zm-.56-5.49.86,2.39,6.44-8.8-12.57-9.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M511.82,99c-.05,0-4.74.58-9.55,1.21a9.93,9.93,0,0,0-8.48,11.59c.84,4.77,1.68,9.43,1.73,9.47l-.13-.1,16.3-22.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 491.92,
    y: 108.97,
    width: 27.59,
    height: 5.38,
    transform: "translate(116.85 453.71) rotate(-53.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M499.73,125.38a1,1,0,0,1-.59-.19L494.8,122a1,1,0,0,1-.22-1.4l16.31-22.26a1,1,0,0,1,.65-.4,1,1,0,0,1,.74.18l4.35,3.18a1,1,0,0,1,.21,1.4L500.54,125a1,1,0,0,1-.66.4ZM496.79,121l2.73,2,15.12-20.65-2.73-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M499.73,124.38l24.44,17.9c4.76,3.48,9.59-.73,9.59-.73l8.91-12.17s2.92-5.62-2.19-9.36L516,102.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M528.24,144.65a7.8,7.8,0,0,1-4.66-1.56L498.33,124.6l17.49-23.88,25.25,18.49a8.3,8.3,0,0,1,2.48,10.63l-.08.13-9.05,12.33A10,10,0,0,1,528.24,144.65Zm-27.11-20.48,23.63,17.31c3.76,2.75,7.68-.15,8.27-.63l8.78-12c.28-.59,2.21-5-1.92-8l-23.64-17.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M518.55,114.2a5.53,5.53,0,1,1-7.74,1.2A5.53,5.53,0,0,1,518.55,114.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M529.07,121.91a5.53,5.53,0,1,1-7.73,1.19A5.53,5.53,0,0,1,529.07,121.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M561.21,362.91a1,1,0,0,1-1-.85l-.07-.51a1,1,0,0,1,.86-1.13,1,1,0,0,1,1.12.86l.07.48a1,1,0,0,1-.84,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M596.39,392a1,1,0,0,1,0-2l.95-.06a1,1,0,0,1,1.06.93,1,1,0,0,1-.93,1.07l-1,.06Zm-2.94,0h0c-.34,0-.68,0-1-.06a1,1,0,1,1,.14-2l1,.05a1,1,0,0,1,0,2Zm6.84-.38a1,1,0,0,1-.16-2l.94-.16a1,1,0,1,1,.37,2c-.33.07-.66.12-1,.18Zm-10.74,0-.15,0-1-.17a1,1,0,0,1,.37-2l.94.17a1,1,0,0,1,.83,1.14A1,1,0,0,1,589.55,391.55Zm14.56-.83a1,1,0,0,1-1-.73,1,1,0,0,1,.7-1.23l.91-.27a1,1,0,0,1,1.25.66,1,1,0,0,1-.66,1.25l-1,.29Zm-18.38,0a1.26,1.26,0,0,1-.27,0l-1-.29a1,1,0,1,1,.59-1.91c.3.1.61.19.91.27a1,1,0,0,1-.26,2Zm22.09-1.26a1,1,0,0,1-.38-1.93l.88-.37a1,1,0,0,1,.81,1.83l-.93.4A1,1,0,0,1,607.82,389.45Zm-25.8,0a1.08,1.08,0,0,1-.38-.08l-.93-.39a1,1,0,1,1,.81-1.83l.88.37a1,1,0,0,1,.55,1.31A1,1,0,0,1,582,389.44Zm29.34-1.68a1,1,0,0,1-.48-1.87l.82-.47a1,1,0,1,1,1,1.72l-.87.5A1,1,0,0,1,611.36,387.76Zm-32.87,0a1.07,1.07,0,0,1-.49-.12l-.87-.5a1,1,0,0,1-.35-1.37,1,1,0,0,1,1.36-.35l.83.46a1,1,0,0,1-.48,1.88Zm36.19-2.07a1,1,0,0,1-.82-.42,1,1,0,0,1,.24-1.39l.76-.56a1,1,0,0,1,1.21,1.59c-.27.21-.54.4-.82.6A1,1,0,0,1,614.68,385.68Zm-39.51,0a1,1,0,0,1-.58-.19l-.81-.59a1,1,0,0,1,1.21-1.6c.25.19.5.38.76.56a1,1,0,0,1-.58,1.82Zm42.57-2.43a1,1,0,0,1-.67-1.75l.7-.64a1,1,0,0,1,1.37,1.45l-.74.68A1,1,0,0,1,617.74,383.24Zm-45.62,0a1,1,0,0,1-.67-.26l-.74-.69a1,1,0,0,1,0-1.41,1,1,0,0,1,1.42,0l.69.64a1,1,0,0,1,.07,1.42A1,1,0,0,1,572.12,383.22Zm48.38-2.76a1,1,0,0,1-.75-1.66l.62-.72a1,1,0,1,1,1.53,1.28c-.21.26-.43.51-.66.76A1,1,0,0,1,620.5,380.46Zm-51.13,0a1,1,0,0,1-.75-.34l-.65-.76a1,1,0,1,1,1.53-1.28l.62.72a1,1,0,0,1-.09,1.41A1,1,0,0,1,569.37,380.43Zm53.55-3a1,1,0,0,1-.58-.18,1,1,0,0,1-.24-1.4l.53-.78a1,1,0,0,1,1.67,1.09c-.18.29-.37.56-.56.84A1,1,0,0,1,622.92,377.39Zm-56,0a1,1,0,0,1-.83-.43c-.19-.28-.38-.56-.56-.84a1,1,0,1,1,1.67-1.09l.54.79a1,1,0,0,1-.25,1.39A1,1,0,0,1,567,377.35Zm58-3.3a1.07,1.07,0,0,1-.48-.12,1,1,0,0,1-.4-1.35l.44-.85a1,1,0,0,1,1.78.9c-.15.3-.3.6-.46.9A1,1,0,0,1,625,374.05Zm-60.06,0a1,1,0,0,1-.88-.53c-.16-.29-.32-.59-.47-.89a1,1,0,0,1,.45-1.34,1,1,0,0,1,1.34.44c.14.28.29.56.44.84a1,1,0,0,1-.88,1.48Zm61.71-3.51a1,1,0,0,1-.37-.07,1,1,0,0,1-.56-1.3c.12-.29.23-.59.34-.88a1,1,0,0,1,1.88.68c-.12.31-.23.63-.36.94A1,1,0,0,1,626.62,370.5Zm-63.37,0a1,1,0,0,1-.93-.63l-.36-.94a1,1,0,0,1,.6-1.29,1,1,0,0,1,1.28.6c.11.3.22.59.34.89a1,1,0,0,1-.56,1.3A.94.94,0,0,1,563.25,370.46Zm64.61-3.68-.27,0a1,1,0,0,1-.7-1.23c.08-.3.16-.61.23-.92a1,1,0,0,1,1.21-.74,1,1,0,0,1,.74,1.2c-.08.33-.16.66-.25,1A1,1,0,0,1,627.86,366.78Zm-65.85,0a1,1,0,0,1-1-.74c-.09-.32-.17-.65-.25-1a1,1,0,0,1,2-.46c.07.31.15.62.23.92a1,1,0,0,1-.71,1.23A1.09,1.09,0,0,1,562,366.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M628.66,362.91h-.14a1,1,0,0,1-.85-1.14l.07-.48a1,1,0,0,1,1.13-.86,1,1,0,0,1,.85,1.13l-.07.5A1,1,0,0,1,628.66,362.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M349.09,375c-3.5-1.72-4.46-5.72-4.89-5.94-.1-.06-.19-.22-.53.1-.95.88.35,4.88.65,5.57a27.41,27.41,0,0,1-4.05,0c-2.83-.18-6.32.87-5.07,3.59.91,2,1.32,2.24,6.62,2.24.81,0,4.47-.37,6.28-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M347.36,380.92c2.23.94,17.71.09,24,0,1.82,0,5.61-2.21,6.15-3.95,2-6.41,6.48-16.2,3.87-26.5-.45-1.76-4.85-2.72-7.27-.76-4.8,3.89-4.78,22-4.78,22s-14,.38-20.88,1.69C345.85,373.87,344.74,379.82,347.36,380.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M353.56,382.36c-3.37,0-5.68-.14-6.59-.52h0c-1.51-.64-2.31-2.43-2.07-4.67.22-2,1.36-4.4,3.34-4.77,5.94-1.13,16.77-1.57,20.07-1.68.07-4.12.62-18.12,5.15-21.79a7,7,0,0,1,6.34-.95,3.55,3.55,0,0,1,2.53,2.25c2.28,9-.68,17.63-2.84,23.91-.38,1.11-.74,2.16-1,3.13-.73,2.31-5,4.62-7.09,4.65-1.56,0-3.7.09-6.06.17C360.68,382.24,356.67,382.36,353.56,382.36Zm23.91-32.74a4.39,4.39,0,0,0-2.75.86c-3.63,2.95-4.42,16.31-4.41,21.21v1l-1,0c-.14,0-14,.39-20.71,1.67-.79.15-1.57,1.51-1.73,3-.1,1,.06,2.28.86,2.62h0c1.47.62,11.5.29,17.49.09,2.37-.08,4.52-.15,6.09-.17s4.84-2.06,5.21-3.25c.31-1,.67-2.05,1.06-3.18,2.08-6.05,4.93-14.33,2.79-22.77-.06-.23-.47-.59-1.22-.84A5.62,5.62,0,0,0,377.47,349.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M344.66,444.08a43.5,43.5,0,0,0-4.92-.87s-11.39,2.34-16.25,1c-2.07-.58-4,3.41.75,4.75A79,79,0,0,0,340,451.75l-.06,1.53L346,455c.25-.91,2.28-3,2.89-5.19C349.4,448,348,444.93,344.66,444.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M346.68,456.22l-6.11-1.71c-1.13-.32-1.84-.52-1.68-1.36l0-.47A83.18,83.18,0,0,1,324,449.9c-2.65-.74-3.39-2.2-3.6-3a3.09,3.09,0,0,1,.83-3,2.61,2.61,0,0,1,2.56-.7c4.58,1.28,15.66-1,15.78-1l.23-.05.24.07.23,0a39.75,39.75,0,0,1,4.67.84h0a6.82,6.82,0,0,1,4.3,3.2,5,5,0,0,1,.64,3.77,14,14,0,0,1-2.1,3.92,9,9,0,0,0-.79,1.27Zm-5.76-3.69,4.55,1.28c.17-.28.39-.59.63-.94a12.58,12.58,0,0,0,1.82-3.33,3.12,3.12,0,0,0-.44-2.23,4.85,4.85,0,0,0-3.07-2.27h0a36,36,0,0,0-4.43-.79l-.21,0c-1.52.3-11.78,2.27-16.55.93a.68.68,0,0,0-.62.21,1.07,1.07,0,0,0-.29,1c.17.67,1,1.24,2.2,1.59A78.14,78.14,0,0,0,340,450.75l1,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M396.53,393.13c-.46-2-2-6.51-3.29-8l-20.59,2.25a31.54,31.54,0,0,0-1.16,7c-8,2.88-15.16,8.3-20.44,11.92,0,0-1.88,1.34-1.91,1.35a5.5,5.5,0,0,0-2.84,3.8c-1.42,7.7-3.92,24.23-6.41,30.65-.94,2.41,2.66,6.6,8.35,6.61,2.44,0,9.31-26.88,8.76-32.08,0,0,14-4.05,22.6-9.65a21.32,21.32,0,0,0,7.88.49,12,12,0,0,0,9-14.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M348.24,449.71h0a10.29,10.29,0,0,1-8.55-4,4.28,4.28,0,0,1-.74-3.93c1.95-5,3.93-16.47,5.38-24.83.37-2.14.7-4.07,1-5.63a6.5,6.5,0,0,1,3.35-4.5l1.68-1.2.12-.08,2.26-1.57c4.92-3.44,11-7.69,17.81-10.25a32.2,32.2,0,0,1,1.16-6.55l.19-.62,21.76-2.38.34.38c1.55,1.75,3.12,6.66,3.52,8.41h0a13,13,0,0,1-9.81,15.54,22.18,22.18,0,0,1-7.92-.39c-7.55,4.82-18.74,8.39-21.75,9.31-.09,6.35-5.62,28.46-8.52,31.68A1.7,1.7,0,0,1,348.24,449.71Zm25.19-61.37a31.73,31.73,0,0,0-.94,6.09l0,.67-.63.23c-6.81,2.44-13,6.76-17.95,10.22-.79.56-1.55,1.08-2.27,1.58l-.1.07c-1.82,1.29-1.82,1.29-1.9,1.33a4.5,4.5,0,0,0-2.32,3.1c-.29,1.56-.62,3.48-1,5.61-1.46,8.44-3.46,20-5.48,25.22a2.39,2.39,0,0,0,.52,2.07,8.33,8.33,0,0,0,6.7,3.18c2.33-2.21,8.49-26,8-31l-.09-.83.81-.23c.14,0,14-4.07,22.32-9.52l.37-.24.42.1a20.53,20.53,0,0,0,7.42.49,11,11,0,0,0,8.3-13.15h0a28.06,28.06,0,0,0-2.77-7.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M415.88,453.28a4.76,4.76,0,0,0-.66.07c-.15,0-6.15,1.51-6.29,1.51s-9,4.32-14.06,4.32c-2.16,0-3,4.37,2,4.37A78.7,78.7,0,0,0,412.75,462l.35,1.49h6.35c0-.93,1.38-3.54,1.38-5.77A5.05,5.05,0,0,0,415.88,453.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M396.87,464.55a5.47,5.47,0,0,1-3.49-1,3.11,3.11,0,0,1-1.2-2.46,2.8,2.8,0,0,1,2.69-2.9c4.76,0,13.54-4.18,13.63-4.22l.2-.1h.13l2.13-.52c2.79-.7,3.72-.93,4.13-1h0l.13,0a4.76,4.76,0,0,1,.66-.06h0a6,6,0,0,1,4.25,1.82,5.35,5.35,0,0,1,1.69,3.63,13.91,13.91,0,0,1-1,4.34,8.7,8.7,0,0,0-.42,1.43v1h-6.35c-1.18,0-1.91,0-2-.86l-.11-.45A83.08,83.08,0,0,1,396.87,464.55Zm12.37-8.73c-1.12.53-9.42,4.36-14.37,4.36-.42,0-.69.47-.69.9a1.12,1.12,0,0,0,.45.9,3.53,3.53,0,0,0,2.24.57A79.18,79.18,0,0,0,412.53,461l1-.22.4,1.68h4.73c.09-.31.22-.67.35-1.07a12.23,12.23,0,0,0,.86-3.7,3.47,3.47,0,0,0-1.1-2.22,4.1,4.1,0,0,0-2.84-1.23h0a2.33,2.33,0,0,0-.38,0l-.25,0c-.48.1-2.55.61-3.8.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M387.78,395.48c2.18-2.5,12.89-3.29,13.26,0,1.75,15.6-5.1,28.16-5.1,31.54,11.86,7.62,17.49,20,22.3,26.84.66.93-7.15,3.39-11.68,1.87,0,0-13.45-16.06-21.2-23.33a5.08,5.08,0,0,1-1.32-4.52S382.43,401.63,387.78,395.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M410.06,457.22a12.25,12.25,0,0,1-3.82-.54l-.26-.09-.19-.22c-.13-.16-13.5-16.1-21.11-23.24a6,6,0,0,1-1.65-5.3c-.07-1.31-.73-14,.68-23.43l2,.3c-1.45,9.68-.66,23-.65,23.12V428a4.07,4.07,0,0,0,1,3.63c7.21,6.75,19.43,21.22,21.1,23.19,3.35,1,8.3-.28,9.86-1.05-1-1.41-2-3-3-4.73-4.26-6.87-9.56-15.43-18.58-21.22l-.46-.3V427a21.72,21.72,0,0,1,1.37-5.33c1.86-5.68,5-15.18,3.73-26.1-.05-.48-.91-.8-1.27-.91-3.2-1-9,.05-10.23,1.46L387,394.82c2-2.3,8.86-3.13,12.33-2.05,2,.64,2.58,1.76,2.67,2.6,1.27,11.35-1.91,21.11-3.81,26.94a34.1,34.1,0,0,0-1.22,4.2c9.08,6,14.39,14.6,18.68,21.52,1.19,1.93,2.32,3.75,3.38,5.25a1.22,1.22,0,0,1-.05,1.48C418.17,455.89,414,457.22,410.06,457.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M400.39,358.67c0-5.49-5.29-10.76-8.7-11.17-5.75.81-13.56.21-15.39,1-3.72,1.66-5.1,7.79-5.37,11.89-.63,9.27,0,23.66-1,34.06-.62,6.18,32.45,9.13,32.45,5.52C402.38,386.42,400.39,364.81,400.39,358.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M395.33,402.55c-8,0-20-1.88-24.32-4.77-1.5-1-2.2-2.15-2.08-3.4.59-5.85.63-12.94.67-19.8,0-5.24.06-10.19.33-14.23.16-2.44,1.08-10.56,6-12.74,1.07-.47,3.18-.54,6.84-.6a79.88,79.88,0,0,0,8.81-.5l.13,0h.13c3.78.46,9.58,6.09,9.58,12.17,0,2.44.32,7.48.7,13.32.57,8.85,1.29,19.85,1.29,28a1.84,1.84,0,0,1-1.13,1.63C401.05,402.26,398.5,402.55,395.33,402.55Zm-3.64-54a82.9,82.9,0,0,1-8.92.5c-2.61,0-5.31.09-6.06.43-3.07,1.37-4.5,6.81-4.78,11-.27,4-.3,8.9-.33,14.11,0,6.91-.08,14-.68,20-.06.66.92,1.53,2.64,2.32,8,3.66,25.85,4.41,27.82,2.93,0-8.07-.72-18.95-1.29-27.71-.38-5.87-.7-10.95-.7-13.45C399.39,353.82,394.65,349,391.69,348.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M383.81,375.11a1.4,1.4,0,0,1-1.45,1.34H352.55a1.35,1.35,0,1,1,0-2.69h29.81A1.41,1.41,0,0,1,383.81,375.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M350.6,375.11a1.9,1.9,0,0,1,1.95-1.85h29.81a1.85,1.85,0,1,1,0,3.69H352.55A1.89,1.89,0,0,1,350.6,375.11Zm1.95-.85a.85.85,0,1,0,0,1.69h29.81a.85.85,0,1,0,0-1.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 320.54,
    y: 345.22,
    width: 41.15,
    height: 28.54,
    rx: 1.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M320,371.78V347.2a2.48,2.48,0,0,1,2.48-2.48h37.19a2.48,2.48,0,0,1,2.48,2.48v24.58a2.48,2.48,0,0,1-2.48,2.48H322.52A2.48,2.48,0,0,1,320,371.78Zm2.48-26.06A1.48,1.48,0,0,0,321,347.2v24.58a1.48,1.48,0,0,0,1.48,1.48h37.19a1.48,1.48,0,0,0,1.48-1.48V347.2a1.49,1.49,0,0,0-1.48-1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M359.46,375.11a1.35,1.35,0,0,0-1.34-1.35H322a1.35,1.35,0,1,0,0,2.69h36.12a1.34,1.34,0,0,0,1.34-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M320,375.11a1.79,1.79,0,0,1,2-1.85h36.12a1.85,1.85,0,0,1,0,3.69H322A1.78,1.78,0,0,1,320,375.11Zm2-.85c-.65,0-1,.28-1,.85s.31.84,1,.84h36.12a.84.84,0,0,0,.84-.84.85.85,0,0,0-.84-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M373.5,327.67c-13.83-3-3.87-11.8-3.87-11.8s.28,3.28,3,2.21c5.12-2.06,16.27-3.34,19.34,3.35,2.38,5.21-2.06,16.62-2.9,19.59-1.38-.87-.22-14.29-5.88-13.73C380.05,327.6,376.53,328.33,373.5,327.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M389.63,342.57l-1.13-.7c-.82-.52-1-1.7-1.31-4.57-.55-4.7-1.29-9.25-3.94-9-.68.06-1.37.15-2.07.24a23.79,23.79,0,0,1-7.89.12h0c-4.63-1-7.31-2.81-8-5.35-1-4,3.46-8,3.65-8.18l1.49-1.31.17,2a2.17,2.17,0,0,0,.65,1.42,1.06,1.06,0,0,0,.94-.06c5-2,17.11-3.81,20.62,3.86,2.19,4.79-.71,13.68-2.27,18.45-.25.77-.45,1.39-.58,1.83Zm-6.11-16.3c4.41,0,5.15,6.47,5.65,10.8,0,.05,0,.11,0,.16,1.44-4.53,3.48-11.78,1.83-15.39-2.72-5.94-13.27-4.75-18.06-2.83a3,3,0,0,1-2.74-.09,3,3,0,0,1-1-1.14c-1.12,1.33-2.37,3.34-1.93,5s2.68,3.07,6.46,3.9a22.81,22.81,0,0,0,7.21-.15c.72-.1,1.43-.18,2.12-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M383.15,327.29c-3.1.31-6.62,1-9.65.38a17.69,17.69,0,0,1-4.1-1.35,3.45,3.45,0,0,0,0,.45c.22,2.56-.18,4.45-.33,8.23-.13,3.17,3.17,8.68,6.51,9.6.35.09,1,.29,1.4.34a7.78,7.78,0,0,0,3.46-.34l.21,4.28h8.92L389,341C387.65,340.15,388.81,326.73,383.15,327.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M375.6,342.05c-2.83-.12-1-4.79.07-4.73S378.42,342.18,375.6,342.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M379.71,348.8c1.64-.39,4.56-.49,9.19-1.05-2.57,6-9.51,11.06-11.56,18.13C376.26,364.7,376.36,351.12,379.71,348.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M380,349.91c.3-.34,1.26-1,1.28-1.37.75-.09.63.19,1.66.09-2.81,2.6-1.19,6.89-2.3,10.8a21.89,21.89,0,0,0-3.3,6.45c-.6-.65-.83-5.11-.35-9.36A14.22,14.22,0,0,1,380,349.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M379.67,350.58a2.47,2.47,0,0,0,2.33.35c.46-.33.91-2.08.91-2.08l-3.49-.52A5.83,5.83,0,0,0,379.67,350.58Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "384.67 352.16 391.69 347.5 389.31 344.89 380.97 348.6 384.67 352.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "378.67 350.22 379.07 348.66 380.42 347.26 380.99 348.46 378.67 350.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M365.16,380c-2.54-2.95-1.86-7-2.16-7.38-.08-.09-.1-.27-.53-.12-1.22.45-1.59,4.64-1.59,5.39a29.35,29.35,0,0,1-3.72-1.6c-2.53-1.28-6.16-1.68-6.07,1.32.07,2.15.34,2.57,5.22,4.65.74.31,4.25,1.41,5.9,2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M362.8,385.5c2.22.94,17.71.09,24,0,1.82,0,5.61-2.21,6.15-3.95,2-6.41,6.47-16.2,3.86-26.5-.44-1.76-6.1-3.1-7.8-1.75-4.83,3.86-4.25,23-4.25,23s-14,.38-20.87,1.69C361.29,378.45,360.18,384.4,362.8,385.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M369,386.94c-3.37,0-5.68-.14-6.58-.52-1.52-.64-2.31-2.43-2.07-4.67.21-2,1.35-4.4,3.34-4.77,5.92-1.13,16.7-1.57,20-1.68-.06-4.31.07-19.11,4.64-22.78l1.25,1.57c-3.64,2.91-4,17-3.87,22.15l0,1-1,0c-.14,0-14,.39-20.72,1.67-.79.15-1.56,1.51-1.72,3-.11,1,.05,2.28.85,2.62,1.48.62,11.5.29,17.5.09,2.37-.08,4.51-.15,6.08-.17s4.84-2.06,5.22-3.25c.3-1,.67-2.05,1.06-3.18,1.42-4.13,3.19-9.28,3.5-14.76l2,.12c-.33,5.75-2.15,11-3.61,15.29-.38,1.11-.74,2.16-1.05,3.13-.72,2.31-5,4.62-7.09,4.65-1.56,0-3.69.09-6.05.17C376.11,386.82,372.1,386.94,369,386.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M114.24,437.37,103.64,427a2.86,2.86,0,0,1-.87-2.1,2.9,2.9,0,0,1,.93-2.08l4.52-4.15a.62.62,0,0,0,.13-.75c-.45-.84-.73-1.35-.9-1.66H98.88A2.89,2.89,0,0,1,96,413.39V399.91A2.89,2.89,0,0,1,98.88,397h7.61a.62.62,0,0,0,.61-.52,10.75,10.75,0,0,1,1.19-3.53.58.58,0,0,0-.09-.68l-5-5.73a2.91,2.91,0,0,1,.12-3.92l9.39-9.49a2.85,2.85,0,0,1,2-.86h0a2.88,2.88,0,0,1,2.06.88l4.51,4.69a.61.61,0,0,0,.7.14c.6-.27,2-.8,4.31-1.58a1.52,1.52,0,0,0,1-1.44v-4.08a2.88,2.88,0,0,1,2.88-2.88h13.48a2.89,2.89,0,0,1,2.88,2.88v5.28a.65.65,0,0,0,.48.61,13.63,13.63,0,0,1,2.9,1.26.6.6,0,0,0,.71-.09l5.15-4.72a2.87,2.87,0,0,1,4,.11l9.58,9.79a2.88,2.88,0,0,1,0,4l-4.82,5.19a.6.6,0,0,0-.09.71,10.55,10.55,0,0,1,1.22,3.5.6.6,0,0,0,.6.51h4.21a2.9,2.9,0,0,1,2.89,2.88v13.48a2.89,2.89,0,0,1-2.89,2.88h-5.18c-.17.3-.46.81-.92,1.65a.63.63,0,0,0,.14.77l4.27,3.64a2.87,2.87,0,0,1,.16,4.23l-10.74,10.66-1.59-1.61L167.48,425a.66.66,0,0,0,.18-.46.65.65,0,0,0-.22-.45l-4.27-3.64a2.89,2.89,0,0,1-.65-3.58c1.55-2.82,1.55-2.82,2.28-2.82h5.8a.62.62,0,0,0,.62-.62V399.91a.61.61,0,0,0-.62-.61h-4.21a2.87,2.87,0,0,1-2.84-2.42,8.37,8.37,0,0,0-.94-2.75,2.84,2.84,0,0,1,.4-3.36l4.81-5.19a.61.61,0,0,0,0-.85l-9.57-9.79a.61.61,0,0,0-.86,0l-5.14,4.72a2.89,2.89,0,0,1-3.36.39,11.39,11.39,0,0,0-2.41-1.06,2.88,2.88,0,0,1-2.12-2.78v-5.28a.62.62,0,0,0-.62-.62H130.25a.62.62,0,0,0-.62.62V375a3.78,3.78,0,0,1-2.55,3.58c-2.13.73-3.59,1.26-4.11,1.5a2.88,2.88,0,0,1-3.26-.63l-4.51-4.69a.57.57,0,0,0-.45-.19.63.63,0,0,0-.44.19l-9.39,9.49a.62.62,0,0,0,0,.84l5,5.73a2.88,2.88,0,0,1,.36,3.27,8.46,8.46,0,0,0-.94,2.78,2.86,2.86,0,0,1-2.84,2.44H98.88a.61.61,0,0,0-.61.61v13.48a.61.61,0,0,0,.61.62h9.21c.74,0,.74,0,2.26,2.86a2.88,2.88,0,0,1-.6,3.47l-4.52,4.16a.62.62,0,0,0,0,.9l10.6,10.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.28,434.16h14.43v-7.34l.73-.28a22.15,22.15,0,0,0,14.26-20.85,22.42,22.42,0,1,0-44.84,0,22.22,22.22,0,0,0,14.68,21.05l.74.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M144.71,435.16H128.28v-7.45l-.09,0a23.22,23.22,0,0,1-15.33-22,23.42,23.42,0,1,1,46.84,0,23.13,23.13,0,0,1-14.9,21.78l-.09,0Zm-14.43-2h12.43v-7l1.37-.52a21.16,21.16,0,0,0,13.62-19.92,21.42,21.42,0,1,0-42.84,0,21.23,21.23,0,0,0,14,20.11l1.4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M141.52,408.59a4.6,4.6,0,1,0-6.3,4.26v24h2.72V413.07A4.61,4.61,0,0,0,141.52,408.59Zm-4.6,1.88a1.88,1.88,0,1,1,1.88-1.88A1.88,1.88,0,0,1,136.92,410.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M138.94,437.81h-4.72V413.49a5.6,5.6,0,1,1,4.72.32Zm-2.72-2h.72V412.27l.78-.18a3.59,3.59,0,1,0-2.13-.16l.63.25Zm.7-24.34a2.88,2.88,0,1,1,2.88-2.88A2.88,2.88,0,0,1,136.92,411.47Zm0-3.75a.88.88,0,1,0,.88.87A.88.88,0,0,0,136.92,407.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M127.63,433a2.7,2.7,0,0,0-2.69,2.69v6.45a2.7,2.7,0,0,0,2.69,2.7h17.3a2.7,2.7,0,0,0,2.69-2.7v-6.45a2.7,2.7,0,0,0-2.69-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M144.93,445.79h-17.3a3.7,3.7,0,0,1-3.69-3.7v-6.45a3.7,3.7,0,0,1,3.69-3.69h17.3a3.69,3.69,0,0,1,3.69,3.69v6.45A3.7,3.7,0,0,1,144.93,445.79ZM127.63,434a1.69,1.69,0,0,0-1.69,1.69v6.45a1.7,1.7,0,0,0,1.69,1.7h17.3a1.7,1.7,0,0,0,1.69-1.7v-6.45a1.69,1.69,0,0,0-1.69-1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M511.71,332.06a5.72,5.72,0,0,1,5.59,5.84,5.87,5.87,0,0,1-.06.85,5.52,5.52,0,0,1,4.33-2.14,5.72,5.72,0,0,1,5.59,5.84,6,6,0,0,1-.75,2.93,5.3,5.3,0,0,1,2.62-.68,5.71,5.71,0,0,1,5.59,5.84,5.93,5.93,0,0,1-2.12,4.58,5.26,5.26,0,0,1,.89-.07,5.71,5.71,0,0,1,5.59,5.84,5.87,5.87,0,0,1-3.13,5.25,5.87,5.87,0,0,1,3.13,5.25,5.72,5.72,0,0,1-5.59,5.84,5.49,5.49,0,0,1-.58,0,6,6,0,0,1,1.81,4.31,5.71,5.71,0,0,1-5.59,5.84,5.43,5.43,0,0,1-2.5-.61,6,6,0,0,1,.63,2.69,5.72,5.72,0,0,1-5.59,5.84,5.5,5.5,0,0,1-4.28-2.08,5.58,5.58,0,0,1-11.14.42h0V337.9A5.72,5.72,0,0,1,511.71,332.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M536.84,366.26a6.68,6.68,0,0,0,2.28-7.51,6.11,6.11,0,0,0-5.35-4.15,6.76,6.76,0,0,0,.3-7.69,6,6,0,0,0-6.69-2.51,6.62,6.62,0,0,0-2.21-7.17,5.92,5.92,0,0,0-7.34.14,6.32,6.32,0,0,0-6.09-5.95,6.41,6.41,0,0,0-6.14,6.63v51.4a.44.44,0,0,0,0,.32v4.12a.5.5,0,0,0,.08.27,6.3,6.3,0,0,0,6.36,5.52,6.2,6.2,0,0,0,5.66-5,6,6,0,0,0,7.36.33,6.55,6.55,0,0,0,2.37-7.08,6,6,0,0,0,6.47-2.28,6.73,6.73,0,0,0,0-7.69,6.32,6.32,0,0,0,5.18-4.16A6.59,6.59,0,0,0,536.84,366.26Zm-3.58,18.32a4.93,4.93,0,0,1-6.42,1.93,6.72,6.72,0,0,1-1.63-2.22c-1.11-2.29-.23-4.71,1.2-6.62.43-.58-.53-1.13-1-.56a9.58,9.58,0,0,0-1.47,2.74,6.52,6.52,0,0,0-8.16-.59c-.58.42,0,1.39.56,1,2.37-1.73,5.3-1.13,7.31.85a6.48,6.48,0,0,0,.33,3.24,7.46,7.46,0,0,0,2.05,3,5.61,5.61,0,0,1-1.46,6.61,4.9,4.9,0,0,1-6.9-.84.5.5,0,0,0-.28-.17c-.78-2.7-.36-5.77,2.23-7.35a.56.56,0,0,0-.57-1c-3.29,2-3.78,6.15-2.42,9.52a5,5,0,0,1-9.92-.23l0-.16V389.8l.32-.37a8.91,8.91,0,0,1,1.24-1.06,5.16,5.16,0,0,1,4.52-.85.55.55,0,0,0,.29-1.07,5.88,5.88,0,0,0-2.42-.19,5.21,5.21,0,0,1,3.2-2.86.56.56,0,0,0-.3-1.07,6.43,6.43,0,0,0-4.22,4.25,7.85,7.85,0,0,0-2.63,1.6V371.06a12.08,12.08,0,0,0,10.08-.31c.64-.32.08-1.28-.56-1a11.23,11.23,0,0,1-3.75,1.07,6.1,6.1,0,0,0-.22-5c-.29-.66-1.25-.09-1,.56.59,1.35.88,3.27-.2,4.47a10.23,10.23,0,0,1-4.39-1.08V357c2.67-1.65,6.1-.49,8.35,1.36.55.45,1.34-.34.79-.79a11.44,11.44,0,0,0-3.08-1.82,4,4,0,0,0,.47-3.6c-.21-.69-1.29-.4-1.07.29a2.92,2.92,0,0,1-.09,2.32,2.67,2.67,0,0,1-.49.6,7,7,0,0,0-4.88.36v-17c0-2.75,1.07-5.35,4-6.09a4.88,4.88,0,0,1,1-.11c3.3.09,5.29,3.06,5,6.18a6,6,0,0,1-.84,2.44c-1.18,2-3.47,2.7-5.68,2.73a.56.56,0,0,0,0,1.12c3.65-.06,7.24-2.18,7.61-6.06a4.94,4.94,0,0,1,6.48-1,5.54,5.54,0,0,1,1.71,7,6.45,6.45,0,0,0-3.05,3.86,4.15,4.15,0,0,1-3.62-2.77.56.56,0,0,0-1.07.3,5.21,5.21,0,0,0,4.46,3.55,7.64,7.64,0,0,0,.47,3.73c.26.66,1.34.37,1.08-.3-1.1-2.83-.35-6,2.44-7.5a5,5,0,0,1,6.57,1.86,5.58,5.58,0,0,1-1.07,7,6.83,6.83,0,0,0-3,1.85,4.8,4.8,0,0,0-1.16,2.14,5.52,5.52,0,0,0-5.83,2.76,7.42,7.42,0,0,0-2.11-2.15c-.59-.4-1.15.56-.56,1a7.44,7.44,0,0,1,2.1,2.67.51.51,0,0,0,.1.21l0,.09a9.43,9.43,0,0,1,.61,5.22.61.61,0,0,0,0,.15,18.93,18.93,0,0,1-1.67,5.13c-.31.64.65,1.21,1,.56a20.74,20.74,0,0,0,1.15-3c1.32,3.94,5.39,6.32,9.63,6.7h.07A5.64,5.64,0,0,1,533.26,384.58Zm-.48-7.75a.4.4,0,0,0-.19,0l-.12,0a13.56,13.56,0,0,1-4.31-1.25,7.68,7.68,0,0,1-4.65-7,.54.54,0,0,0-.06-.25,11.29,11.29,0,0,0-.58-5.68,4.45,4.45,0,0,1,5-2.89,9,9,0,0,0,.83,4c.28.66,1.24.09,1-.56-.88-2.06-1.14-4.39.55-6.09a5.48,5.48,0,0,1,2.38-1.37,5.1,5.1,0,0,1,5.52,3.62,5.48,5.48,0,0,1-2.41,6.33,6.58,6.58,0,0,0-7.86,4.25c-.26.67.82.95,1.08.29a5.42,5.42,0,0,1,6.64-3.42C540.34,369.47,538.47,377.3,532.78,376.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M497.53,332.06a5.72,5.72,0,0,0-5.6,5.84,7.73,7.73,0,0,0,.06.85,5.5,5.5,0,0,0-4.32-2.14,5.73,5.73,0,0,0-5.6,5.84,6.1,6.1,0,0,0,.75,2.93,5.3,5.3,0,0,0-2.62-.68,5.71,5.71,0,0,0-5.59,5.84,5.91,5.91,0,0,0,2.13,4.58,5.29,5.29,0,0,0-.9-.07,5.71,5.71,0,0,0-5.59,5.84,5.86,5.86,0,0,0,3.14,5.25,5.86,5.86,0,0,0-3.14,5.25,5.61,5.61,0,0,0,6.18,5.81,5.93,5.93,0,0,0-1.82,4.31,5.71,5.71,0,0,0,5.59,5.84,5.4,5.4,0,0,0,2.5-.61,6,6,0,0,0-.63,2.69,5.73,5.73,0,0,0,5.6,5.84,5.49,5.49,0,0,0,4.27-2.08,5.58,5.58,0,0,0,11.15.42h0V337.9A5.71,5.71,0,0,0,497.53,332.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M503.79,344c0-3.78.83-8.76-2.54-11.38a6,6,0,0,0-3.59-1.23,6.32,6.32,0,0,0-6.09,5.95,6,6,0,0,0-7.24-.23,6.55,6.55,0,0,0-2.32,7.25,6.09,6.09,0,0,0-6.68,2.52,6.61,6.61,0,0,0,.3,7.69,6.26,6.26,0,0,0-5.36,4.15,6.58,6.58,0,0,0,2.29,7.51,6.68,6.68,0,0,0-2.38,7.23,6.19,6.19,0,0,0,5.27,4.43,6.76,6.76,0,0,0-.12,7.46A6,6,0,0,0,482,387.9a6.62,6.62,0,0,0,2.26,7,5.93,5.93,0,0,0,7.47-.24,6.3,6.3,0,0,0,5.67,5c3.3.28,5.84-2.47,6.36-5.52a.6.6,0,0,0,.07-.27v-4.12a.44.44,0,0,0,0-.32V344Zm-30,22.75a5.44,5.44,0,0,1,6.65,3.42c.26.66,1.34.38,1.07-.29a6.58,6.58,0,0,0-7.86-4.25,5.54,5.54,0,0,1-2.41-6.33,5.07,5.07,0,0,1,5.52-3.62A5.72,5.72,0,0,1,479,357c1.83,1.64,1.55,4.13.66,6.2-.27.65.69,1.22,1,.56a8.91,8.91,0,0,0,.81-4,4.48,4.48,0,0,1,5,2.89,11.4,11.4,0,0,0-.59,5.68.71.71,0,0,0-.06.25,7.69,7.69,0,0,1-4.65,7,13.24,13.24,0,0,1-4.31,1.25l-.12,0a.39.39,0,0,0-.19,0C470.92,377.3,469.05,369.47,473.8,366.78Zm23.56,31.79a5.13,5.13,0,0,1-4.64-4.43c1.37-3.38.87-7.52-2.42-9.53a.56.56,0,0,0-.56,1c2.58,1.58,3,4.65,2.22,7.35a.45.45,0,0,0-.27.17,5,5,0,0,1-6.56,1.09,5.52,5.52,0,0,1-1.8-6.86,7.82,7.82,0,0,0,2-3,6,6,0,0,0,.35-3.25c2-2,4.93-2.57,7.29-.84.59.42,1.14-.55.57-1a6.55,6.55,0,0,0-8.17.58,9.76,9.76,0,0,0-1.47-2.73c-.42-.57-1.39,0-1,.56,1.48,2,2.25,4.28,1.21,6.62a6.49,6.49,0,0,1-1.63,2.22,4.93,4.93,0,0,1-6.27-1.69,5.58,5.58,0,0,1,.57-6.88h.06c4.25-.38,8.31-2.76,9.63-6.7a22,22,0,0,0,1.15,3c.31.65,1.27.08,1-.56-1.54-3.22-2.55-7.06-1.09-10.5l.05-.09a.55.55,0,0,0,.11-.23,7.25,7.25,0,0,1,2.09-2.65c.59-.4,0-1.36-.56-1a7.42,7.42,0,0,0-2.11,2.15,5.51,5.51,0,0,0-5.85-2.76,5.35,5.35,0,0,0-1-2,6.45,6.45,0,0,0-3.07-2,5.6,5.6,0,0,1-1.07-7,4.93,4.93,0,0,1,6.57-1.86,5.83,5.83,0,0,1,2.44,7.5c-.26.67.81,1,1.07.3a7.64,7.64,0,0,0,.47-3.73,5.2,5.2,0,0,0,4.46-3.55.56.56,0,0,0-1.07-.3,4.12,4.12,0,0,1-3.61,2.77,6.49,6.49,0,0,0-3.05-3.86,5.6,5.6,0,0,1,1.37-6.79,4.89,4.89,0,0,1,6.81.75c.37,3.88,4,6,7.62,6.06a.56.56,0,0,0,0-1.12c-2.27,0-4.44-.74-5.69-2.73a5.93,5.93,0,0,1-.84-2.44c-.32-3.12,1.66-6.09,5-6.18a5.25,5.25,0,0,1,5,5.32v17.86a7,7,0,0,0-4.89-.36,3.37,3.37,0,0,1-.42-.49,2.77,2.77,0,0,1-.15-2.43c.21-.69-.86-1-1.08-.29a4,4,0,0,0,.47,3.6,11.64,11.64,0,0,0-3.07,1.82c-.56.45.23,1.24.78.79,2.26-1.85,5.68-3,8.36-1.36v12.84a10.28,10.28,0,0,1-4.4,1.08c-1.07-1.2-.79-3.12-.2-4.47.29-.65-.67-1.22-1-.56a6.1,6.1,0,0,0-.22,5,11.11,11.11,0,0,1-3.74-1.07c-.65-.32-1.21.64-.57,1a12.1,12.1,0,0,0,10.09.31v17.12a7.89,7.89,0,0,0-2.64-1.6,6.43,6.43,0,0,0-4.22-4.25.55.55,0,0,0-.29,1.07,5.26,5.26,0,0,1,3.2,2.86,5.93,5.93,0,0,0-2.43.19.56.56,0,0,0,.3,1.07,5.2,5.2,0,0,1,4.51.85,8.37,8.37,0,0,1,1.24,1.06l.33.37v3.95a.66.66,0,0,0,0,.15A5.19,5.19,0,0,1,497.36,398.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M470.42,362.7a44.19,44.19,0,0,0,19.12,69.46v10.66h30.12V432.25a44.42,44.42,0,0,0,29.26-41.63,44,44,0,0,0-10-27.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M520.66,443.82H488.54v-11a45.18,45.18,0,0,1-18.89-70.78l.3-.37h69.48l.3.37A45.2,45.2,0,0,1,520.66,433Zm-30.12-2h28.12V431.55l.67-.24a43.2,43.2,0,0,0,19.15-67.61H470.9a43.19,43.19,0,0,0,19,67.52l.66.24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 489.71,
    y: 442.56,
    width: 29.76,
    height: 13.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M519.47,457.08H489.71a1,1,0,0,1-1-1V442.56a1,1,0,0,1,1-1h29.76a1,1,0,0,1,1,1v13.52A1,1,0,0,1,519.47,457.08Zm-28.76-2h27.76V443.56H490.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M485.65,455h0a1.7,1.7,0,0,0,1.7,1.7h34.08a1.7,1.7,0,0,0,1.7-1.7h0a1.7,1.7,0,0,0-1.7-1.7H487.35A1.7,1.7,0,0,0,485.65,455Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M521.43,457.68H487.35a2.7,2.7,0,0,1,0-5.4h34.08a2.7,2.7,0,1,1,0,5.4Zm-34.08-3.4a.7.7,0,1,0,0,1.4h34.08a.7.7,0,0,0,0-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M485.65,448.35h0a1.7,1.7,0,0,0,1.7,1.71h34.08a1.7,1.7,0,0,0,1.7-1.71h0a1.7,1.7,0,0,0-1.7-1.7H487.35A1.7,1.7,0,0,0,485.65,448.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M521.43,451.06H487.35a2.71,2.71,0,0,1,0-5.41h34.08a2.71,2.71,0,0,1,0,5.41Zm-34.08-3.41a.71.71,0,0,0,0,1.41h34.08a.71.71,0,0,0,0-1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M485.65,441.73h0a1.7,1.7,0,0,0,1.7,1.7h34.08a1.7,1.7,0,0,0,1.7-1.7h0a1.7,1.7,0,0,0-1.7-1.7H487.35A1.7,1.7,0,0,0,485.65,441.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M521.43,444.43H487.35a2.7,2.7,0,0,1,0-5.4h34.08a2.7,2.7,0,1,1,0,5.4ZM487.35,441a.7.7,0,1,0,0,1.4h34.08a.7.7,0,0,0,0-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M612.09,420.28c-1.09-7-11.11-19.41-15.34-24.13v23.66A2.66,2.66,0,0,1,598,422a2.76,2.76,0,1,1-5.51,0,2.61,2.61,0,0,1,1.17-2.16V396c-3.92,4.31-16,18.15-16,25.65,0,9,7.45,15.85,7.45,15.85h19.55S613.46,429.23,612.09,420.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M605,438.5H584.7l-.29-.27c-.31-.29-7.77-7.29-7.77-16.58,0-7.67,11.36-21,16.24-26.32l1.74-1.91v26.94l-.43.3a1.62,1.62,0,0,0-.74,1.34,1.76,1.76,0,1,0,3.51,0,1.63,1.63,0,0,0-.77-1.36l-.44-.3v-26.8l1.75,1.94c.58.65,14.24,16,15.58,24.65h0c1.43,9.36-7.38,17.75-7.76,18.1Zm-19.53-2h18.73c1.43-1.46,8-8.62,6.87-16.07h0c-.89-5.76-8.34-15.72-13.35-21.61v20.51A3.59,3.59,0,0,1,599,422a3.76,3.76,0,1,1-7.51,0,3.56,3.56,0,0,1,1.17-2.64V398.63c-4.77,5.44-14,16.76-14,23C578.64,429.1,584.2,435.18,585.5,436.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 591.08,
    y: 387.56,
    width: 7.72,
    height: 7.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M598.8,396.27h-7.72a1,1,0,0,1-1-1v-7.71a1,1,0,0,1,1-1h7.72a1,1,0,0,1,1,1v7.71A1,1,0,0,1,598.8,396.27Zm-6.72-2h5.72v-5.71h-5.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 624.87,
    y: 356.88,
    width: 7.72,
    height: 7.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M632.59,365.6h-7.72a1,1,0,0,1-1-1v-7.72a1,1,0,0,1,1-1h7.72a1,1,0,0,1,1,1v7.72A1,1,0,0,1,632.59,365.6Zm-6.72-2h5.72v-5.72h-5.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 557.28,
    y: 356.88,
    width: 7.72,
    height: 7.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M565,365.6h-7.72a1,1,0,0,1-1-1v-7.72a1,1,0,0,1,1-1H565a1,1,0,0,1,1,1v7.72A1,1,0,0,1,565,365.6Zm-6.72-2H564v-5.72h-5.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M180,171.23s.52-.54,1-1.09l.88-1.07,0-.06a1,1,0,0,1,1.54,1.25l-1,1.25-1,1.1a1,1,0,0,1-1.41,0,1,1,0,0,1,0-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M184.32,165l.6-1.38.49-1.33,0-.05a1,1,0,0,1,1.82.68l-.54,1.48c-.3.69-.59,1.38-.59,1.38a1,1,0,0,1-1.8-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M186.59,157.61l.21-1.48.14-1.43v0a1,1,0,1,1,1.9.18l-.15,1.56c-.1.74-.21,1.48-.21,1.48a1,1,0,1,1-1.9-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M186.94,149.87l-.15-1.49c-.1-.71-.21-1.42-.21-1.42v-.05a.93.93,0,0,1,1.85-.27s.12.77.23,1.55l.16,1.49a.94.94,0,0,1-1.88.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M185.4,142.29l-.53-1.41c-.28-.65-.57-1.3-.57-1.3l0-.05a.92.92,0,1,1,1.68-.74s.32.72.63,1.44l.54,1.4a.93.93,0,1,1-1.73.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M181.88,135.44l-.92-1.18-.94-1.07,0,0a.9.9,0,1,1,1.35-1.19l1,1.19.92,1.18a.9.9,0,0,1-1.42,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M176.43,130l-1.26-.82-1.23-.71,0,0a.88.88,0,0,1,.87-1.52l1.37.78,1.26.82a.89.89,0,0,1-1,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M169.51,126.65l-1.44-.41-1.4-.32h0a.86.86,0,0,1-.64-1,.84.84,0,0,1,1-.65l1.53.35,1.44.4a.87.87,0,1,1-.46,1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M161.86,125.3l-1.5-.06h-1.49a.84.84,0,0,1,0-1.68h1.55l1.49,0a.85.85,0,1,1,0,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M154,125.59l-3,.45a.82.82,0,0,1-.25-1.63l3-.46a.83.83,0,0,1,.25,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M146.28,127.08l-2.89.82a.81.81,0,0,1-.44-1.55l2.89-.83a.81.81,0,1,1,.44,1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M138.74,129.48l-2.79,1.1a.78.78,0,1,1-.58-1.45l2.78-1.12a.79.79,0,0,1,1,.44.8.8,0,0,1-.44,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M131.45,132.61,128.78,134a.76.76,0,0,1-.7-1.36l2.67-1.37a.78.78,0,0,1,1,.34.77.77,0,0,1-.33,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M124.47,136.38,121.92,138a.75.75,0,0,1-.78-1.27l2.54-1.59a.75.75,0,0,1,.8,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M117.85,140.74l-2.41,1.79a.73.73,0,1,1-.87-1.16l2.39-1.81a.73.73,0,0,1,1,.15.72.72,0,0,1-.14,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M111.63,145.66l-2.22,2a.71.71,0,0,1-1-.05.7.7,0,0,1,0-1l2.22-2a.72.72,0,0,1,1,.05.7.7,0,0,1-.05,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M105.93,151.16l-2,2.24a.69.69,0,0,1-1,0,.68.68,0,0,1,0-1l2-2.24a.69.69,0,0,1,1-.06.69.69,0,0,1,.06,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M100.88,157.25l-1.71,2.47a.67.67,0,0,1-.93.17.66.66,0,0,1-.17-.93l1.69-2.48a.68.68,0,0,1,.94-.18.69.69,0,0,1,.18.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M96.69,164,96,165.29l-.62,1.33v0a.65.65,0,1,1-1.18-.54l.64-1.4.67-1.34a.65.65,0,0,1,.88-.3.66.66,0,0,1,.3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M93.67,171.22s-.2.72-.41,1.44l-.34,1.42v0a.63.63,0,0,1-1.23-.29l.36-1.5.4-1.44a.64.64,0,0,1,.79-.44.62.62,0,0,1,.44.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M92.22,178.92s0,.75-.07,1.5v1.48a.62.62,0,1,1-1.23,0v-1.55c0-.75.07-1.5.07-1.5a.61.61,0,0,1,.64-.59.63.63,0,0,1,.6.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M92.66,186.73,93,188.2c.18.7.37,1.41.37,1.41v0a.59.59,0,0,1-.42.73.61.61,0,0,1-.73-.42s-.19-.75-.39-1.49L91.48,187a.6.6,0,1,1,1.17-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M95,194.2s.33.67.65,1.35l.69,1.3v0a.58.58,0,0,1-.24.78.59.59,0,0,1-.78-.24l-.72-1.36c-.33-.67-.65-1.35-.65-1.35a.58.58,0,1,1,1-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M99,201l.93,1.18,1,1.1v0a.56.56,0,0,1,0,.79.57.57,0,0,1-.79-.05l-1-1.16-.93-1.17a.56.56,0,0,1,.09-.8A.57.57,0,0,1,99,201Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M104.53,206.53l1.22.88,1.23.77,0,0a.54.54,0,1,1-.58.92l-1.31-.82-1.22-.87a.55.55,0,0,1,.63-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M111.4,210.19l1.45.41,1.41.29h0a.53.53,0,0,1,.41.62.54.54,0,0,1-.62.41l-1.53-.31-1.45-.41a.53.53,0,0,1-.36-.66.52.52,0,0,1,.65-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M119.07,211s.77-.1,1.44-.26,1.38-.41,1.38-.41h0a.51.51,0,0,1,.65.3.51.51,0,0,1-.31.65,14.64,14.64,0,0,1-1.49.45c-.79.19-1.51.29-1.51.29h0a.51.51,0,0,1-.14-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M125.82,207.78l.3-.36a9.06,9.06,0,0,0,.58-.77,9.45,9.45,0,0,0,.46-.86l.19-.4,0,0a.49.49,0,0,1,.89.42l-.21.45a9.63,9.63,0,0,1-.52,1c-.23.32-.46.68-.64.88l-.3.36a.5.5,0,1,1-.77-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M128,200.74l-.07-.47c0-.29-.11-.62-.17-1-.16-.71-.39-1.4-.39-1.4a.48.48,0,0,1,.91-.3s.24.73.41,1.49c.08.38.17.78.2,1s.06.47.06.47a.48.48,0,0,1-.41.54.48.48,0,0,1-.54-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M125.24,193.49l-.25-.4-.12-.19c0-.06-.09-.12-.13-.19l-.32-.45-.85-1.24a.46.46,0,0,1,.12-.64.45.45,0,0,1,.63.12l.86,1.23.32.45.15.23a1,1,0,0,1,.12.19l.26.39a.48.48,0,0,1-.15.65.47.47,0,0,1-.64-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M120.36,187.33l-1.1-1-1.13-.94h0a.44.44,0,0,1-.06-.62.43.43,0,0,1,.62-.06l1.19,1,1.11,1a.45.45,0,0,1-.61.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M114,182.75l-1.36-.63-1.36-.53h0A.43.43,0,0,1,111,181a.42.42,0,0,1,.55-.24l1.44.55,1.36.62a.43.43,0,0,1-.35.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M106.52,180.49l-1.49-.12-1.46,0h0a.41.41,0,0,1-.4-.41.4.4,0,0,1,.41-.4l1.54,0,1.5.11a.42.42,0,1,1-.07.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M98.73,181l-1.44.42-1.37.51h0a.39.39,0,0,1-.5-.23.39.39,0,0,1,.23-.5l1.45-.54,1.43-.43a.41.41,0,0,1,.5.27.4.4,0,0,1-.27.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M91.7,184.35s-.6.47-1.12,1-1,1.06-1,1.06a.37.37,0,0,1-.52,0,.36.36,0,0,1,0-.52s.5-.59,1.06-1.12,1.15-1,1.15-1h0a.38.38,0,0,1,.47.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M86.59,190.3l-.79,1.28-.72,1.28v0a.36.36,0,0,1-.49.13.35.35,0,0,1-.13-.48l.74-1.33.79-1.28a.37.37,0,0,1,.5-.12.36.36,0,0,1,.11.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M83.08,197.37s-.23.72-.47,1.43-.39,1.42-.39,1.42v0a.33.33,0,0,1-.41.23.33.33,0,0,1-.24-.41l.4-1.47.46-1.43a.35.35,0,0,1,.44-.22.34.34,0,0,1,.22.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M81.4,205.09s-.05.75-.09,1.49l0,1.48v0a.32.32,0,0,1-.33.31.32.32,0,0,1-.32-.32l0-1.52.08-1.5a.33.33,0,0,1,.35-.31.33.33,0,0,1,.31.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M81.73,213l.28,1.47.36,1.43v0a.31.31,0,0,1-.22.37.3.3,0,0,1-.37-.22s-.19-.74-.37-1.48l-.3-1.47a.32.32,0,0,1,.25-.37.32.32,0,0,1,.37.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M84,220.53s.32.68.65,1.35l.7,1.3v0a.29.29,0,0,1-.12.39.3.3,0,0,1-.39-.12l-.73-1.33-.66-1.35a.31.31,0,0,1,.14-.4.3.3,0,0,1,.4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M88.19,227.26l1,1.14,1,1.07h0a.28.28,0,0,1,0,.39.28.28,0,0,1-.38,0s-.53-.55-1-1.11l-1-1.13a.27.27,0,0,1,0-.39.28.28,0,0,1,.39,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M93.94,232.68l1.24.84,1.27.77h0a.26.26,0,0,1,.09.35.25.25,0,0,1-.35.08L94.89,234l-1.24-.84a.26.26,0,1,1,.29-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M100.93,236.38l1.42.48,1.43.41h0a.24.24,0,0,1,.16.3.24.24,0,0,1-.29.16l-1.46-.41-1.43-.48a.24.24,0,0,1,.16-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M108.65,238.12l1.5.1,1.48,0h0a.22.22,0,0,1,.22.23.21.21,0,0,1-.23.21l-1.51,0-1.5-.1a.22.22,0,0,1-.21-.24.22.22,0,0,1,.24-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M116.58,237.91l1.48-.23,1.46-.29h0a.2.2,0,0,1,.24.17.21.21,0,0,1-.16.24l-1.48.3-1.48.24a.21.21,0,0,1-.24-.17.22.22,0,0,1,.17-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M124.3,236l2.81-1.07a.19.19,0,1,1,.13.35l-2.8,1.08a.19.19,0,1,1-.14-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M131.6,232.84l2.61-1.48a.16.16,0,0,1,.23.07.17.17,0,0,1-.06.23l-2.61,1.49a.17.17,0,0,1-.24-.07.17.17,0,0,1,.07-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M138.38,228.64l2.42-1.78a.15.15,0,0,1,.21,0,.15.15,0,0,1,0,.21l-2.41,1.79a.15.15,0,0,1-.22,0,.16.16,0,0,1,0-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M144.65,223.71l2.23-2a.15.15,0,0,1,.2,0,.14.14,0,0,1,0,.2l-2.22,2a.15.15,0,0,1-.21,0,.14.14,0,0,1,0-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M150.45,218.22l2.07-2.18a.12.12,0,0,1,.18.17l-2.06,2.18a.12.12,0,0,1-.18,0,.14.14,0,0,1,0-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M155.83,212.31l1.92-2.31a.09.09,0,0,1,.14,0,.1.1,0,0,1,0,.14L156,212.45a.11.11,0,0,1-.16,0,.11.11,0,0,1,0-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M160.8,206.05l1.69-2.47a.09.09,0,0,1,.12,0,.08.08,0,0,1,0,.12L161,206.16a.09.09,0,0,1-.13,0,.09.09,0,0,1,0-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M165.16,199.35l1.55-2.56a.07.07,0,0,1,.09,0,.08.08,0,0,1,0,.09l-1.54,2.57a.08.08,0,0,1-.11,0,.09.09,0,0,1,0-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M169.24,192.49l1.5-2.6a.06.06,0,0,1,.07,0,.07.07,0,0,1,0,.07l-1.49,2.61a.07.07,0,0,1-.08,0,.08.08,0,0,1,0-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M173.21,185.54l1.46-2.62h0a0,0,0,0,1,0,0l-1.45,2.63s0,0-.05,0,0,0,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M177.09,178.55l1.44-2.63h0l-1.43,2.64s0,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M130.17,158l49.74,8.87a2.46,2.46,0,0,1,1.83,1.35,2.41,2.41,0,0,1-.07,2.26L175,182.29l4.24,7.34-9.07,4.29-.91-1.54-3.16,8.78-10.39-5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M130.17,158c5.68.81,11.34,1.72,17,2.59,2.84.43,5.67.91,8.5,1.37l8.49,1.39,8.49,1.39,4.24.72,2.12.37,1.14.21.52.14a4.86,4.86,0,0,1,.71.37,3.32,3.32,0,0,1,1.45,2.39l0,.42c0,.13,0,.24,0,.36a2.39,2.39,0,0,1-.18.71,7.35,7.35,0,0,1-.54,1.09L180,175.26l-4.21,7.5v-.95l4.27,7.32.55.94-1,.46-9.09,4.25-.8.37-.44-.75-.9-1.54,1.71-.16-3.2,8.76-.36,1-.92-.49-10.36-5.63-.19-.1-.11-.17-12.5-19c-2.09-3.16-4.11-6.36-6.18-9.54S132.19,161.19,130.17,158Zm0,0q3.35,4.59,6.62,9.22c2.19,3.09,4.42,6.16,6.58,9.27l13,18.62-.3-.27,10.41,5.53-1.28.49,3.12-8.79.67-1.9,1,1.73.92,1.54-1.23-.38,9.05-4.32-.43,1.4-4.21-7.36-.27-.48.27-.47,4.28-7.46,2.14-3.74a5.12,5.12,0,0,0,.43-.82.78.78,0,0,0,.09-.33c0-.05,0-.11,0-.16s0-.08,0-.12a1.62,1.62,0,0,0-.65-1.19c-.09,0-.11-.09-.23-.15l-.51-.14-1-.18-2.11-.39-4.23-.79-8.45-1.63-8.45-1.63c-2.81-.54-5.63-1.07-8.44-1.65C141.41,160.29,135.78,159.19,130.17,158Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M130.11,157.36a.58.58,0,0,1,.57-.27l54.46,8.33a2.49,2.49,0,0,1,1.82,1.35,2.4,2.4,0,0,1-.07,2.27l-17.68,31.12a2.45,2.45,0,0,1-1.91,1.22,2.42,2.42,0,0,1-2.09-.88l-35-42.51A.58.58,0,0,1,130.11,157.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M130.11,157.36a.69.69,0,0,1,.36-.26,6.24,6.24,0,0,1,1.29.15l4.92.73,7.65,1.12,9.93,1.38,24.88,3.33,3.44.46,1.74.23.88.12h.05l.16,0,.1,0,.22.05.21.06.3.15a3.06,3.06,0,0,1,1.61,1.78,1.77,1.77,0,0,1,.14.47c0,.23.06.46.08.69a3.42,3.42,0,0,1-.25,1.19,6.79,6.79,0,0,1-.45.9l-.43.78-.88,1.58c-2.32,4.23-4.75,8.48-7.14,12.75s-4.85,8.51-7.29,12.67l-.91,1.56-.45.78-.23.39-.06.09-.09.14,0,0-.14.18a3.35,3.35,0,0,1-.9.82,3.29,3.29,0,0,1-1.12.41l-.3.06s-.24,0-.16,0h-.17a2.69,2.69,0,0,1-.47,0c-.22-.05-.44-.1-.65-.17a3.53,3.53,0,0,1-.55-.28,3.58,3.58,0,0,1-.86-.77l-.55-.69-1.09-1.38-2.16-2.72-15.59-19.67-6.27-7.82-4.87-6-3.15-3.85a7.47,7.47,0,0,1-.79-1A.66.66,0,0,1,130.11,157.36Zm0,0a.63.63,0,0,0,0,.44,6.16,6.16,0,0,0,.79,1l3.18,3.82c1.37,1.65,3,3.64,5,5.93l6.48,7.65,16.34,19.06c.74.87,1.5,1.75,2.25,2.64.38.44.76.89,1.15,1.33l.57.67c.1.12.16.14.23.22a.56.56,0,0,0,.24.16,3.42,3.42,0,0,0,.44.19c.09,0,.28,0,.42,0h.11l.14,0a1.63,1.63,0,0,0,.53-.21c.12-.14.2-.07.4-.39l.14-.18,0,0c.06-.1,0,.08,0,0l.05-.1.22-.39.44-.79.87-1.58c2.32-4.22,4.75-8.47,7.15-12.74s4.85-8.52,7.29-12.67l.91-1.56.45-.78a4,4,0,0,0,.37-.69,1.49,1.49,0,0,0,.14-.54.67.67,0,0,1,0-.2s0-.09,0-.17l-.07-.21-.08-.21s.06.14,0,0l0,0,0-.06a1.94,1.94,0,0,0-.15-.24,1.64,1.64,0,0,0-.4-.34c0-.1-.58-.21-.62-.24l-.87-.15-1.73-.3-3.42-.59-24.73-4.27-9.89-1.66L136.68,158l-4.92-.77a6.4,6.4,0,0,0-1.29-.16A.69.69,0,0,0,130.11,157.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M142.7,164.84l31.74,26.1,4.76-1.31,1-8.78L143,164.35a.28.28,0,0,0-.27.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M142.7,164.84l4,3.24c1.32,1.08,2.67,2.14,4,3.2,2.67,2.14,5.41,4.21,8.12,6.31l8.13,6.28Q171,187,175,190.21l-.85-.19,4.75-1.34-.72.84c.29-2.93.67-5.85,1-8.77l.56,1c-3.08-1.43-6.15-2.85-9.21-4.34L161.41,173c-3.06-1.46-6.11-3-9.19-4.39l-4.61-2.15L143,164.35h0a.26.26,0,0,0-.21,0,.33.33,0,0,0-.16.13.27.27,0,0,0,0,.2A.33.33,0,0,0,142.7,164.84Zm0,0a.37.37,0,0,1-.13-.17.39.39,0,0,1,0-.21.29.29,0,0,1,.16-.13.3.3,0,0,1,.21,0h0l4.67,2,4.68,2c3.13,1.33,6.28,2.57,9.42,3.86l9.43,3.84c3.15,1.27,6.28,2.59,9.4,3.92l.64.27-.08.71c-.31,2.93-.59,5.86-.95,8.78l-.08.67-.64.17-4.77,1.27-.49.13-.36-.31c-2.61-2.22-5.21-4.44-7.78-6.71l-7.74-6.77c-2.58-2.25-5.14-4.54-7.75-6.74-1.31-1.11-2.6-2.24-3.92-3.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-177",
    x: 354.09,
    y: 128.95,
    width: 40,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 611.15,
    y: 209.95,
    width: 22.36,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 297.33,
    y: 181.34,
    width: 22.36,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 552.21,
    y: 189.32,
    width: 10.14,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M643.75,290.53a3.43,3.43,0,1,1,3.43-3.43A3.44,3.44,0,0,1,643.75,290.53Zm0-4.86a1.43,1.43,0,1,0,1.43,1.43A1.44,1.44,0,0,0,643.75,285.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M354.09,158.14a3.44,3.44,0,1,1,3.43-3.43A3.44,3.44,0,0,1,354.09,158.14Zm0-4.87a1.44,1.44,0,1,0,1.43,1.44A1.44,1.44,0,0,0,354.09,153.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M204.53,154.71a3.44,3.44,0,1,1,3.43-3.44A3.44,3.44,0,0,1,204.53,154.71Zm0-4.87a1.44,1.44,0,1,0,1.43,1.43A1.44,1.44,0,0,0,204.53,149.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M112.8,344.45a3.43,3.43,0,1,1,3.43-3.43A3.44,3.44,0,0,1,112.8,344.45Zm0-4.86a1.43,1.43,0,1,0,1.43,1.43A1.43,1.43,0,0,0,112.8,339.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 94.35,
    y: 258.75,
    width: 5.68,
    height: 2,
    transform: "translate(-155.24 144.88) rotate(-45.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 96.19,
    y: 256.91,
    width: 2,
    height: 5.68,
    transform: "translate(-155.2 144.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 532.32,
    y: 282.33,
    width: 22.36,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: 548.92,
    y: 251.71,
    width: 5.68,
    height: 2,
    transform: "translate(-17.09 464.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-189",
    x: 550.75,
    y: 249.87,
    width: 2,
    height: 5.68,
    transform: "translate(-17.09 464.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 597.07,
    y: 248.99,
    width: 40,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 479.73,
    y: 82.73,
    width: 40,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 451.42,
    y: 128.95,
    width: 29.05,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 440.47,
    y: 128.95,
    width: 7.92,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 217.96,
    y: 125.84,
    width: 22.36,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 455.4,
    y: 91.66,
    width: 10.14,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M574.21,215.38a3.43,3.43,0,1,1,3.43-3.43A3.44,3.44,0,0,1,574.21,215.38Zm0-4.86a1.43,1.43,0,1,0,1.43,1.43A1.43,1.43,0,0,0,574.21,210.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M431.53,87.16A3.43,3.43,0,1,1,435,83.73,3.44,3.44,0,0,1,431.53,87.16Zm0-4.86A1.43,1.43,0,1,0,433,83.73,1.43,1.43,0,0,0,431.53,82.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 331.46,
    y: 86.16,
    width: 5.68,
    height: 2,
    transform: "translate(36.28 261.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 331.46,
    y: 86.16,
    width: 5.68,
    height: 2,
    transform: "translate(36.28 261.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 333.3,
    y: 84.32,
    width: 2,
    height: 5.68,
    transform: "translate(36.28 261.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 198.98,
    y: 97.94,
    width: 5.68,
    height: 2,
    transform: "translate(-10.85 171.68) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 198.98,
    y: 97.94,
    width: 5.68,
    height: 2,
    transform: "translate(-10.85 171.68) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 200.82,
    y: 96.1,
    width: 2,
    height: 5.68,
    transform: "translate(-10.85 171.68) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 301.74,
    y: 130.66,
    width: 29.05,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 290.79,
    y: 130.66,
    width: 7.92,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-204",
    x: 98.21,
    y: 356.2,
    width: 29.05,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-205",
    x: 87.26,
    y: 356.2,
    width: 7.92,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 89.91,
    y: 236.74,
    width: 22.36,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 152.32,
    y: 112.13,
    width: 29.05,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 141.37,
    y: 112.13,
    width: 7.92,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 267.26,
    y: 129.66,
    width: 5.68,
    height: 2,
    transform: "translate(-13.28 229.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 267.26,
    y: 129.66,
    width: 5.68,
    height: 2,
    transform: "translate(-13.28 229.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 269.1,
    y: 127.82,
    width: 2,
    height: 5.68,
    transform: "translate(-13.29 229.23) rotate(-44.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 370.7,
    y: 112.13,
    width: 5.68,
    height: 2,
    transform: "translate(29.42 297.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 370.7,
    y: 112.13,
    width: 5.68,
    height: 2,
    transform: "translate(29.42 297.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 372.54,
    y: 110.29,
    width: 2,
    height: 5.68,
    transform: "translate(29.39 297.22) rotate(-44.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 380.53,
    y: 92.66,
    width: 29.05,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 369.58,
    y: 92.66,
    width: 7.92,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 467.41,
    y: 108.41,
    width: 5.68,
    height: 2,
    transform: "translate(60.37 364.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 467.41,
    y: 108.41,
    width: 5.68,
    height: 2,
    transform: "translate(60.37 364.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 469.25,
    y: 106.57,
    width: 2,
    height: 5.68,
    transform: "translate(60.34 364.51) rotate(-44.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 619.49,
    y: 228.24,
    width: 5.68,
    height: 2,
    transform: "translate(20.17 507.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 621.33,
    y: 226.4,
    width: 2,
    height: 5.68,
    transform: "translate(20.18 507.2) rotate(-45)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog4);
export default __webpack_public_path__ + "static/media/blog4.60aa6cecd146aaa676c8c080eb0f4fae.svg";
export { ForwardRef as ReactComponent };